<svg
  viewBox={$$props.patternViewBox ?? "0 0 624 379"}
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...$$props}
>
  <g clip-path="url(#clip0_6493_27950)">
    <path
      d="M318.303 197.491C318.303 200.247 315.948 202.517 313.106 202.517C310.264 202.517 307.91 200.247 307.91 197.491C307.91 194.734 310.264 192.464 313.106 192.464C315.948 192.464 318.303 194.734 318.303 197.491Z"
      fill={$$props.pathColor}
    />
    <path
      d="M317.576 151.205C317.576 153.556 315.546 155.502 313.11 155.502C310.674 155.502 308.645 153.556 308.645 151.205C308.645 148.854 310.674 146.908 313.11 146.908C315.546 146.908 317.576 148.854 317.576 151.205Z"
      fill={$$props.pathColor}
    />
    <path
      d="M318.952 219.306C318.952 222.306 316.435 224.657 313.431 224.657C310.427 224.657 307.91 222.225 307.91 219.306C307.91 216.306 310.427 213.955 313.431 213.955C316.435 213.955 318.952 216.387 318.952 219.306Z"
      fill={$$props.pathColor}
    />
    <path
      d="M318.064 174.712C318.064 177.388 315.791 179.577 313.03 179.577C310.269 179.577 307.996 177.388 307.996 174.712C307.996 172.037 310.269 169.848 313.03 169.848C315.791 169.848 318.064 172.037 318.064 174.712Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.104 105.878C314.898 105.878 316.352 104.463 316.352 102.716C316.352 100.97 314.898 99.5544 313.104 99.5544C311.31 99.5544 309.856 100.97 309.856 102.716C309.856 104.463 311.31 105.878 313.104 105.878Z"
      fill={$$props.pathColor}
    />
    <path
      d="M316.851 127.447C316.851 129.474 315.146 131.015 313.116 131.015C311.086 131.015 309.381 129.393 309.381 127.447C309.381 125.421 311.086 123.88 313.116 123.88C315.146 123.88 316.851 125.502 316.851 127.447Z"
      fill={$$props.pathColor}
    />
    <path
      d="M315.627 79.0573C315.627 80.4356 314.409 81.6517 312.947 81.6517C311.486 81.6517 310.268 80.5167 310.268 79.0573C310.268 77.679 311.486 76.4629 312.947 76.4629C314.409 76.4629 315.627 77.5979 315.627 79.0573Z"
      fill={$$props.pathColor}
    />
    <path
      d="M315.052 54.4778C315.052 55.5318 314.159 56.3425 313.103 56.3425C312.048 56.3425 311.155 55.5318 311.155 54.4778C311.155 53.4238 312.048 52.613 313.103 52.613C314.159 52.613 315.052 53.4238 315.052 54.4778Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.103 30.0911C314 30.0911 314.727 29.4014 314.727 28.5507C314.727 27.6999 314 27.0103 313.103 27.0103C312.206 27.0103 311.479 27.6999 311.479 28.5507C311.479 29.4014 312.206 30.0911 313.103 30.0911Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.698 1.49734C314.047 1.14905 314.047 0.584376 313.698 0.236095C313.35 -0.112186 312.784 -0.112183 312.435 0.236099C312.086 0.58438 312.086 1.14904 312.435 1.49732C312.784 1.8456 313.35 1.84562 313.698 1.49734Z"
      fill={$$props.pathColor}
    />
    <path
      d="M337.097 199.09C337.387 196.329 335.309 193.848 332.455 193.548C329.6 193.249 327.051 195.244 326.76 198.005C326.47 200.766 328.548 203.247 331.402 203.547C334.257 203.846 336.806 201.851 337.097 199.09Z"
      fill={$$props.pathColor}
    />
    <path
      d="M341.213 152.959C341.461 150.598 339.674 148.476 337.221 148.219C334.768 147.962 332.579 149.666 332.33 152.026C332.082 154.387 333.869 156.508 336.322 156.766C338.775 157.023 340.965 155.319 341.213 152.959Z"
      fill={$$props.pathColor}
    />
    <path
      d="M335.483 220.845C335.792 217.906 333.584 215.265 330.552 214.947C327.519 214.629 324.81 216.753 324.5 219.692C324.191 222.631 326.399 225.272 329.431 225.59C332.464 225.908 335.173 223.784 335.483 220.845Z"
      fill={$$props.pathColor}
    />
    <path
      d="M339.353 176.363C339.634 173.691 337.621 171.29 334.856 171C332.091 170.709 329.621 172.64 329.34 175.312C329.059 177.984 331.072 180.385 333.837 180.675C336.602 180.966 339.072 179.035 339.353 176.363Z"
      fill={$$props.pathColor}
    />
    <path
      d="M345.184 104.684C345.367 102.947 344.069 101.388 342.285 101.201C340.501 101.013 338.906 102.27 338.724 104.006C338.541 105.743 339.839 107.303 341.623 107.49C343.407 107.677 345.001 106.421 345.184 104.684Z"
      fill={$$props.pathColor}
    />
    <path
      d="M342.971 129.25C343.177 127.291 341.681 125.528 339.63 125.313C337.578 125.098 335.748 126.511 335.542 128.471C335.336 130.43 336.832 132.193 338.883 132.408C340.935 132.624 342.765 131.21 342.971 129.25Z"
      fill={$$props.pathColor}
    />
    <path
      d="M346.936 80.9996C347.086 79.5746 346.014 78.2942 344.542 78.1398C343.071 77.9853 341.756 79.0153 341.606 80.4403C341.456 81.8653 342.528 83.1457 343.999 83.3002C345.471 83.4546 346.786 82.4246 346.936 80.9996Z"
      fill={$$props.pathColor}
    />
    <path
      d="M348.975 56.5972C349.083 55.573 348.303 54.6516 347.232 54.5393C346.162 54.427 345.207 55.1662 345.099 56.1904C344.991 57.2146 345.772 58.136 346.842 58.2483C347.912 58.3606 348.867 57.6214 348.975 56.5972Z"
      fill={$$props.pathColor}
    />
    <path
      d="M351.368 30.6873C351.457 29.8412 350.807 29.0795 349.915 28.9859C349.023 28.8923 348.227 29.5023 348.138 30.3484C348.049 31.1945 348.7 31.9563 349.592 32.0499C350.484 32.1435 351.279 31.5334 351.368 30.6873Z"
      fill={$$props.pathColor}
    />
    <path
      d="M353.235 3.68282C353.618 3.37286 353.677 2.81129 353.367 2.42851C353.056 2.04573 352.494 1.98669 352.11 2.29666C351.727 2.60663 351.668 3.16821 351.978 3.55099C352.289 3.93377 352.851 3.99279 353.235 3.68282Z"
      fill={$$props.pathColor}
    />
    <path
      d="M355.749 202.626C356.327 199.91 354.52 197.226 351.713 196.63C348.905 196.034 346.161 197.753 345.583 200.468C345.005 203.184 346.812 205.868 349.619 206.464C352.427 207.06 355.171 205.341 355.749 202.626Z"
      fill={$$props.pathColor}
    />
    <path
      d="M364.682 157.197C365.176 154.876 363.621 152.579 361.209 152.067C358.796 151.555 356.44 153.022 355.946 155.343C355.451 157.664 357.007 159.961 359.419 160.473C361.832 160.985 364.188 159.519 364.682 157.197Z"
      fill={$$props.pathColor}
    />
    <path
      d="M351.801 224.085C352.417 221.194 350.497 218.337 347.515 217.704C344.532 217.071 341.615 218.901 341 221.792C340.384 224.683 342.303 227.539 345.286 228.172C348.269 228.805 351.186 226.975 351.801 224.085Z"
      fill={$$props.pathColor}
    />
    <path
      d="M360.309 180.318C360.868 177.69 359.117 175.091 356.398 174.514C353.678 173.937 351.02 175.599 350.461 178.227C349.901 180.855 351.652 183.454 354.372 184.031C357.092 184.608 359.75 182.945 360.309 180.318Z"
      fill={$$props.pathColor}
    />
    <path
      d="M373.638 109.54C374.002 107.832 372.874 106.146 371.119 105.773C369.365 105.401 367.648 106.484 367.284 108.192C366.921 109.9 368.048 111.587 369.803 111.959C371.557 112.331 373.274 111.248 373.638 109.54Z"
      fill={$$props.pathColor}
    />
    <path
      d="M368.92 133.759C369.33 131.832 368.027 129.922 366.009 129.494C363.991 129.066 362.023 130.281 361.613 132.208C361.203 134.135 362.506 136.045 364.524 136.473C366.541 136.901 368.51 135.686 368.92 133.759Z"
      fill={$$props.pathColor}
    />
    <path
      d="M377.816 86.2049C378.114 84.8034 377.182 83.4182 375.735 83.111C374.287 82.8037 372.872 83.6909 372.574 85.0924C372.275 86.494 373.207 87.8792 374.654 88.1864C376.102 88.4936 377.517 87.6065 377.816 86.2049Z"
      fill={$$props.pathColor}
    />
    <path
      d="M382.379 62.051C382.593 61.0437 381.914 60.0459 380.861 59.8225C379.808 59.5991 378.781 60.2345 378.567 61.2419C378.352 62.2493 379.032 63.247 380.085 63.4705C381.137 63.6939 382.165 63.0584 382.379 62.051Z"
      fill={$$props.pathColor}
    />
    <path
      d="M387.473 36.6308C387.651 35.7987 387.083 34.9732 386.206 34.787C385.329 34.6008 384.474 35.1244 384.297 35.9566C384.119 36.7888 384.687 37.6143 385.564 37.8005C386.442 37.9867 387.296 37.463 387.473 36.6308Z"
      fill={$$props.pathColor}
    />
    <path
      d="M392.102 9.99308C392.516 9.72483 392.633 9.17249 392.365 8.75941C392.096 8.34632 391.543 8.22892 391.129 8.49718C390.716 8.76544 390.598 9.31778 390.867 9.73086C391.135 10.1439 391.688 10.2613 392.102 9.99308Z"
      fill={$$props.pathColor}
    />
    <path
      d="M373.868 208.117C374.728 205.477 373.211 202.619 370.482 201.733C367.752 200.847 364.843 202.27 363.984 204.91C363.125 207.551 364.641 210.409 367.37 211.294C370.1 212.18 373.009 210.757 373.868 208.117Z"
      fill={$$props.pathColor}
    />
    <path
      d="M387.462 163.93C388.197 161.673 386.89 159.226 384.545 158.465C382.199 157.704 379.702 158.917 378.968 161.174C378.233 163.431 379.539 165.878 381.885 166.639C384.231 167.4 386.728 166.187 387.462 163.93Z"
      fill={$$props.pathColor}
    />
    <path
      d="M367.664 229.088C368.578 226.278 366.969 223.237 364.069 222.296C361.168 221.355 358.076 222.871 357.161 225.681C356.247 228.492 357.856 231.533 360.757 232.474C363.657 233.415 366.749 231.899 367.664 229.088Z"
      fill={$$props.pathColor}
    />
    <path
      d="M380.779 186.4C381.61 183.845 380.141 181.078 377.496 180.22C374.852 179.362 372.034 180.738 371.203 183.293C370.372 185.848 371.841 188.615 374.485 189.473C377.13 190.331 379.947 188.955 380.779 186.4Z"
      fill={$$props.pathColor}
    />
    <path
      d="M401.43 117.402C401.971 115.742 401.026 113.947 399.32 113.393C397.614 112.84 395.793 113.737 395.252 115.398C394.712 117.059 395.657 118.854 397.363 119.407C399.069 119.961 400.89 119.063 401.43 117.402Z"
      fill={$$props.pathColor}
    />
    <path
      d="M394.132 141.037C394.742 139.163 393.645 137.129 391.684 136.492C389.722 135.856 387.637 136.859 387.027 138.732C386.418 140.606 387.514 142.641 389.476 143.277C391.437 143.914 393.522 142.911 394.132 141.037Z"
      fill={$$props.pathColor}
    />
    <path
      d="M408.027 94.6942C408.47 93.3314 407.689 91.8566 406.281 91.4C404.874 90.9434 403.373 91.6779 402.93 93.0406C402.486 94.4034 403.268 95.8782 404.675 96.3348C406.083 96.7914 407.583 96.0569 408.027 94.6942Z"
      fill={$$props.pathColor}
    />
    <path
      d="M415.108 71.1093C415.426 70.1298 414.855 69.0666 413.832 68.7345C412.808 68.4025 411.72 68.9273 411.401 69.9067C411.082 70.8862 411.654 71.9494 412.677 72.2815C413.701 72.6135 414.789 72.0887 415.108 71.1093Z"
      fill={$$props.pathColor}
    />
    <path
      d="M422.784 46.3286C423.048 45.5195 422.57 44.6392 421.717 44.3625C420.864 44.0858 419.959 44.5174 419.695 45.3265C419.432 46.1356 419.91 47.0158 420.763 47.2926C421.616 47.5693 422.521 47.1377 422.784 46.3286Z"
      fill={$$props.pathColor}
    />
    <path
      d="M430.15 20.2308C430.589 20.0071 430.764 19.4701 430.54 19.0313C430.316 18.5924 429.778 18.4179 429.339 18.6415C428.899 18.8651 428.724 19.4022 428.948 19.841C429.172 20.2799 429.71 20.4544 430.15 20.2308Z"
      fill={$$props.pathColor}
    />
    <path
      d="M391.278 215.423C392.408 212.886 391.2 209.886 388.578 208.72C385.956 207.554 382.914 208.665 381.783 211.202C380.652 213.738 381.861 216.739 384.483 217.904C387.105 219.07 390.147 217.959 391.278 215.423Z"
      fill={$$props.pathColor}
    />
    <path
      d="M409.485 172.884C410.451 170.716 409.408 168.146 407.155 167.144C404.902 166.143 402.292 167.088 401.325 169.256C400.358 171.424 401.401 173.994 403.654 174.995C405.908 175.997 408.518 175.052 409.485 172.884Z"
      fill={$$props.pathColor}
    />
    <path
      d="M382.918 235.626C384.122 232.926 382.839 229.734 380.053 228.495C377.268 227.257 374.033 228.442 372.83 231.141C371.626 233.841 372.908 237.034 375.694 238.272C378.48 239.511 381.714 238.326 382.918 235.626Z"
      fill={$$props.pathColor}
    />
    <path
      d="M400.391 194.533C401.485 192.078 400.313 189.173 397.774 188.044C395.234 186.915 392.287 187.989 391.193 190.444C390.099 192.898 391.27 195.803 393.81 196.932C396.35 198.061 399.297 196.987 400.391 194.533Z"
      fill={$$props.pathColor}
    />
    <path
      d="M428.128 128.132C428.84 126.537 428.088 124.653 426.449 123.924C424.81 123.196 422.905 123.899 422.194 125.494C421.483 127.089 422.234 128.973 423.873 129.702C425.512 130.43 427.417 129.727 428.128 128.132Z"
      fill={$$props.pathColor}
    />
    <path
      d="M418.475 150.816C419.277 149.017 418.4 146.878 416.516 146.041C414.631 145.203 412.453 145.983 411.65 147.783C410.848 149.582 411.725 151.721 413.609 152.558C415.494 153.396 417.672 152.616 418.475 150.816Z"
      fill={$$props.pathColor}
    />
    <path
      d="M437.222 106.114C437.805 104.805 437.183 103.257 435.831 102.656C434.479 102.055 432.91 102.629 432.326 103.938C431.742 105.246 432.365 106.795 433.717 107.396C435.069 107.997 436.638 107.423 437.222 106.114Z"
      fill={$$props.pathColor}
    />
    <path
      d="M446.645 83.549C447.064 82.6082 446.607 81.4912 445.624 81.0541C444.641 80.617 443.504 81.0253 443.084 81.9662C442.665 82.907 443.122 84.024 444.105 84.4611C445.088 84.8982 446.225 84.4899 446.645 83.549Z"
      fill={$$props.pathColor}
    />
    <path
      d="M456.952 59.6235C457.299 58.8462 456.915 57.9209 456.096 57.5567C455.277 57.1924 454.331 57.5272 453.985 58.3044C453.638 59.0816 454.022 60.007 454.841 60.3712C455.66 60.7354 456.605 60.4007 456.952 59.6235Z"
      fill={$$props.pathColor}
    />
    <path
      d="M467.077 34.567C467.538 34.3905 467.768 33.8746 467.591 33.4148C467.414 32.955 466.898 32.7253 466.437 32.9018C465.977 33.0783 465.747 33.5942 465.923 34.054C466.1 34.5139 466.617 34.7435 467.077 34.567Z"
      fill={$$props.pathColor}
    />
    <path
      d="M407.869 224.529C409.259 222.125 408.371 219.015 405.885 217.582C403.4 216.149 400.258 216.936 398.868 219.341C397.478 221.745 398.365 224.855 400.851 226.288C403.336 227.721 406.478 226.934 407.869 224.529Z"
      fill={$$props.pathColor}
    />
    <path
      d="M430.36 184.091C431.549 182.036 430.78 179.371 428.644 178.14C426.508 176.909 423.813 177.577 422.625 179.632C421.437 181.687 422.205 184.351 424.341 185.583C426.477 186.814 429.172 186.146 430.36 184.091Z"
      fill={$$props.pathColor}
    />
    <path
      d="M397.474 243.812C398.954 241.253 398.013 237.944 395.372 236.422C392.731 234.899 389.391 235.74 387.911 238.299C386.431 240.858 387.372 244.167 390.013 245.69C392.654 247.212 395.994 246.371 397.474 243.812Z"
      fill={$$props.pathColor}
    />
    <path
      d="M419.167 204.726C420.512 202.4 419.651 199.388 417.243 198C414.835 196.612 411.792 197.373 410.447 199.7C409.102 202.026 409.963 205.038 412.371 206.426C414.779 207.814 417.821 207.053 419.167 204.726Z"
      fill={$$props.pathColor}
    />
    <path
      d="M453.686 141.548C454.561 140.036 454.01 138.084 452.457 137.188C450.904 136.293 448.935 136.793 448.061 138.305C447.186 139.817 447.737 141.769 449.29 142.665C450.844 143.56 452.812 143.06 453.686 141.548Z"
      fill={$$props.pathColor}
    />
    <path
      d="M441.71 163.108C442.696 161.402 442.048 159.184 440.261 158.154C438.475 157.124 436.227 157.672 435.24 159.379C434.254 161.085 434.902 163.303 436.689 164.333C438.475 165.363 440.723 164.814 441.71 163.108Z"
      fill={$$props.pathColor}
    />
    <path
      d="M464.988 120.695C465.705 119.454 465.248 117.849 463.966 117.11C462.685 116.372 461.064 116.779 460.347 118.02C459.629 119.26 460.087 120.865 461.368 121.604C462.65 122.343 464.27 121.936 464.988 120.695Z"
      fill={$$props.pathColor}
    />
    <path
      d="M476.662 99.1283C477.177 98.2364 476.84 97.0778 475.908 96.5405C474.976 96.0031 473.802 96.2906 473.286 97.1825C472.771 98.0744 473.108 99.233 474.04 99.7703C474.972 100.308 476.146 100.02 476.662 99.1283Z"
      fill={$$props.pathColor}
    />
    <path
      d="M489.458 76.5118C489.884 75.775 489.6 74.8148 488.823 74.367C488.046 73.9193 487.071 74.1535 486.645 74.8903C486.219 75.6271 486.503 76.5874 487.28 77.0351C488.057 77.4829 489.032 77.2486 489.458 76.5118Z"
      fill={$$props.pathColor}
    />
    <path
      d="M502.105 52.5907C502.581 52.4632 502.864 51.9742 502.736 51.4984C502.609 51.0227 502.119 50.7403 501.643 50.8678C501.166 50.9953 500.883 51.4843 501.011 51.9601C501.139 52.4358 501.628 52.7182 502.105 52.5907Z"
      fill={$$props.pathColor}
    />
    <path
      d="M423.403 235.272C425.037 233.026 424.48 229.84 422.158 228.155C419.836 226.471 416.629 226.926 414.995 229.172C413.36 231.418 413.918 234.604 416.24 236.288C418.562 237.973 421.769 237.518 423.403 235.272Z"
      fill={$$props.pathColor}
    />
    <path
      d="M450.024 197.433C451.421 195.513 450.936 192.783 448.94 191.335C446.945 189.888 444.195 190.271 442.798 192.191C441.401 194.111 441.886 196.84 443.882 198.288C445.877 199.736 448.627 199.353 450.024 197.433Z"
      fill={$$props.pathColor}
    />
    <path
      d="M411.01 253.353C412.749 250.962 412.16 247.573 409.693 245.783C407.226 243.993 403.816 244.481 402.076 246.872C400.336 249.263 400.926 252.652 403.393 254.441C405.86 256.231 409.27 255.744 411.01 253.353Z"
      fill={$$props.pathColor}
    />
    <path
      d="M436.696 216.794C438.278 214.621 437.736 211.536 435.487 209.904C433.238 208.272 430.132 208.711 428.551 210.885C426.969 213.058 427.51 216.143 429.76 217.775C432.009 219.407 435.115 218.968 436.696 216.794Z"
      fill={$$props.pathColor}
    />
    <path
      d="M477.631 157.576C478.659 156.164 478.316 154.165 476.865 153.112C475.413 152.059 473.404 152.351 472.376 153.764C471.348 155.177 471.691 157.175 473.142 158.228C474.593 159.281 476.603 158.989 477.631 157.576Z"
      fill={$$props.pathColor}
    />
    <path
      d="M463.426 177.818C464.586 176.224 464.173 173.95 462.504 172.74C460.835 171.529 458.542 171.84 457.383 173.434C456.223 175.027 456.636 177.301 458.304 178.512C459.973 179.722 462.266 179.412 463.426 177.818Z"
      fill={$$props.pathColor}
    />
    <path
      d="M491.002 137.999C491.845 136.839 491.559 135.196 490.361 134.327C489.164 133.459 487.51 133.694 486.666 134.853C485.823 136.013 486.11 137.656 487.307 138.525C488.504 139.394 490.158 139.158 491.002 137.999Z"
      fill={$$props.pathColor}
    />
    <path
      d="M505.031 117.756C505.637 116.923 505.422 115.735 504.552 115.104C503.681 114.472 502.484 114.635 501.877 115.468C501.271 116.302 501.486 117.489 502.356 118.121C503.227 118.752 504.424 118.589 505.031 117.756Z"
      fill={$$props.pathColor}
    />
    <path
      d="M519.978 96.5576C520.479 95.8694 520.297 94.8847 519.571 94.3583C518.846 93.832 517.852 93.9632 517.351 94.6515C516.85 95.3397 517.032 96.3244 517.758 96.8508C518.483 97.3772 519.478 97.2459 519.978 96.5576Z"
      fill={$$props.pathColor}
    />
    <path
      d="M535.173 74.0817C535.66 74.0046 535.993 73.5478 535.915 73.0613C535.838 72.5748 535.381 72.2429 534.894 72.32C534.406 72.397 534.074 72.8538 534.151 73.3403C534.228 73.8268 534.686 74.1587 535.173 74.0817Z"
      fill={$$props.pathColor}
    />
    <path
      d="M437.666 247.722C439.527 245.659 439.306 242.432 437.173 240.515C435.04 238.597 431.803 238.715 429.943 240.778C428.082 242.841 428.303 246.068 430.436 247.986C432.569 249.903 435.806 249.785 437.666 247.722Z"
      fill={$$props.pathColor}
    />
    <path
      d="M468.198 212.812C469.788 211.048 469.591 208.283 467.758 206.635C465.925 204.987 463.15 205.081 461.56 206.844C459.97 208.608 460.166 211.373 461.999 213.021C463.832 214.669 466.607 214.575 468.198 212.812Z"
      fill={$$props.pathColor}
    />
    <path
      d="M423.525 264.406C425.506 262.21 425.274 258.778 423.008 256.741C420.742 254.703 417.299 254.832 415.319 257.028C413.339 259.224 413.57 262.656 415.836 264.694C418.103 266.731 421.545 266.602 423.525 264.406Z"
      fill={$$props.pathColor}
    />
    <path
      d="M452.85 230.615C454.65 228.618 454.435 225.494 452.369 223.636C450.303 221.779 447.168 221.891 445.368 223.888C443.567 225.884 443.783 229.009 445.849 230.866C447.915 232.724 451.05 232.611 452.85 230.615Z"
      fill={$$props.pathColor}
    />
    <path
      d="M499.787 175.994C500.957 174.696 500.825 172.673 499.492 171.474C498.159 170.276 496.13 170.356 494.96 171.654C493.789 172.952 493.921 174.975 495.254 176.174C496.587 177.372 498.617 177.292 499.787 175.994Z"
      fill={$$props.pathColor}
    />
    <path
      d="M483.562 194.696C484.882 193.232 484.71 190.927 483.177 189.549C481.644 188.171 479.331 188.241 478.01 189.705C476.69 191.169 476.863 193.473 478.396 194.851C479.929 196.229 482.242 196.16 483.562 194.696Z"
      fill={$$props.pathColor}
    />
    <path
      d="M515.198 157.932C516.158 156.867 516.045 155.202 514.946 154.213C513.846 153.225 512.176 153.286 511.216 154.351C510.255 155.416 510.369 157.081 511.468 158.069C512.568 159.058 514.238 158.996 515.198 157.932Z"
      fill={$$props.pathColor}
    />
    <path
      d="M531.213 139.252C531.903 138.487 531.814 137.284 531.014 136.565C530.214 135.846 529.006 135.883 528.316 136.648C527.626 137.414 527.715 138.617 528.515 139.336C529.315 140.055 530.523 140.018 531.213 139.252Z"
      fill={$$props.pathColor}
    />
    <path
      d="M548.36 119.798C548.93 119.166 548.852 118.167 548.186 117.568C547.519 116.969 546.517 116.996 545.947 117.628C545.376 118.26 545.455 119.258 546.121 119.858C546.788 120.457 547.79 120.43 548.36 119.798Z"
      fill={$$props.pathColor}
    />
    <path
      d="M565.739 99.0175C566.232 98.9917 566.61 98.5721 566.584 98.0802C566.558 97.5884 566.138 97.2105 565.646 97.2363C565.153 97.2621 564.775 97.6817 564.8 98.1736C564.826 98.6654 565.246 99.0433 565.739 99.0175Z"
      fill={$$props.pathColor}
    />
    <path
      d="M450.662 261.501C452.728 259.643 452.846 256.411 450.926 254.281C449.005 252.152 445.774 251.931 443.707 253.789C441.641 255.646 441.523 258.879 443.444 261.008C445.364 263.138 448.596 263.359 450.662 261.501Z"
      fill={$$props.pathColor}
    />
    <path
      d="M484.643 230.021C486.41 228.433 486.503 225.662 484.853 223.832C483.203 222.002 480.433 221.806 478.667 223.394C476.901 224.982 476.807 227.753 478.457 229.583C480.107 231.413 482.877 231.609 484.643 230.021Z"
      fill={$$props.pathColor}
    />
    <path
      d="M434.831 276.612C437.03 274.635 437.159 271.197 435.119 268.935C433.078 266.672 429.641 266.441 427.442 268.418C425.242 270.395 425.113 273.833 427.154 276.096C429.194 278.358 432.631 278.59 434.831 276.612Z"
      fill={$$props.pathColor}
    />
    <path
      d="M467.502 246.111C469.502 244.313 469.614 241.183 467.754 239.12C465.894 237.057 462.765 236.842 460.765 238.64C458.765 240.437 458.653 243.567 460.513 245.63C462.373 247.693 465.503 247.908 467.502 246.111Z"
      fill={$$props.pathColor}
    />
    <path
      d="M519.877 196.684C521.176 195.515 521.257 193.489 520.057 192.158C518.856 190.827 516.83 190.695 515.53 191.864C514.23 193.032 514.15 195.058 515.35 196.39C516.55 197.721 518.577 197.852 519.877 196.684Z"
      fill={$$props.pathColor}
    />
    <path
      d="M501.792 213.475C503.259 212.157 503.328 209.847 501.948 208.317C500.568 206.786 498.26 206.614 496.794 207.932C495.327 209.25 495.258 211.56 496.638 213.091C498.018 214.621 500.326 214.793 501.792 213.475Z"
      fill={$$props.pathColor}
    />
    <path
      d="M537.083 180.291C538.15 179.332 538.211 177.665 537.221 176.567C536.231 175.468 534.564 175.356 533.497 176.314C532.431 177.273 532.369 178.94 533.359 180.039C534.35 181.137 536.017 181.25 537.083 180.291Z"
      fill={$$props.pathColor}
    />
    <path
      d="M554.968 163.441C555.734 162.752 555.772 161.546 555.052 160.747C554.332 159.949 553.127 159.86 552.36 160.549C551.594 161.238 551.556 162.444 552.276 163.243C552.996 164.042 554.201 164.13 554.968 163.441Z"
      fill={$$props.pathColor}
    />
    <path
      d="M574.131 145.82C574.764 145.251 574.791 144.25 574.191 143.584C573.591 142.919 572.591 142.841 571.958 143.41C571.325 143.979 571.298 144.98 571.898 145.646C572.498 146.311 573.498 146.389 574.131 145.82Z"
      fill={$$props.pathColor}
    />
    <path
      d="M594.37 126.164C594.393 125.717 594.049 125.336 593.601 125.312C593.154 125.289 592.772 125.632 592.748 126.079C592.725 126.527 593.069 126.908 593.516 126.932C593.964 126.955 594.346 126.611 594.37 126.164Z"
      fill={$$props.pathColor}
    />
    <path
      d="M462.111 276.531C464.361 274.899 464.817 271.697 463.13 269.379C461.443 267.06 458.252 266.504 456.002 268.135C453.753 269.767 453.297 272.97 454.984 275.288C456.671 277.606 459.862 278.163 462.111 276.531Z"
      fill={$$props.pathColor}
    />
    <path
      d="M499.192 248.791C501.115 247.396 501.499 244.651 500.049 242.658C498.599 240.666 495.865 240.181 493.942 241.576C492.02 242.971 491.636 245.717 493.086 247.71C494.536 249.702 497.27 250.186 499.192 248.791Z"
      fill={$$props.pathColor}
    />
    <path
      d="M444.67 289.85C447.064 288.113 447.552 284.708 445.76 282.245C443.968 279.782 440.573 279.193 438.179 280.93C435.785 282.667 435.297 286.072 437.089 288.535C438.881 290.999 442.275 291.587 444.67 289.85Z"
      fill={$$props.pathColor}
    />
    <path
      d="M480.482 263.054C482.659 261.475 483.099 258.374 481.464 256.128C479.83 253.882 476.741 253.342 474.564 254.921C472.387 256.5 471.947 259.601 473.582 261.847C475.216 264.093 478.305 264.633 480.482 263.054Z"
      fill={$$props.pathColor}
    />
    <path
      d="M537.795 219.313C539.21 218.286 539.502 216.28 538.448 214.831C537.394 213.382 535.392 213.039 533.977 214.066C532.562 215.092 532.27 217.099 533.324 218.548C534.379 219.997 536.38 220.339 537.795 219.313Z"
      fill={$$props.pathColor}
    />
    <path
      d="M518.014 234.167C519.61 233.009 519.921 230.719 518.709 229.053C517.496 227.387 515.219 226.975 513.623 228.133C512.027 229.291 511.716 231.58 512.928 233.247C514.141 234.913 516.418 235.325 518.014 234.167Z"
      fill={$$props.pathColor}
    />
    <path
      d="M556.593 204.79C557.754 203.948 557.99 202.296 557.12 201.101C556.25 199.906 554.604 199.619 553.443 200.461C552.282 201.304 552.046 202.955 552.916 204.151C553.785 205.346 555.432 205.633 556.593 204.79Z"
      fill={$$props.pathColor}
    />
    <path
      d="M576.106 189.864C576.941 189.258 577.104 188.063 576.472 187.193C575.839 186.324 574.65 186.11 573.815 186.715C572.981 187.321 572.817 188.516 573.45 189.385C574.082 190.255 575.272 190.469 576.106 189.864Z"
      fill={$$props.pathColor}
    />
    <path
      d="M596.944 174.402C597.633 173.902 597.765 172.909 597.237 172.185C596.71 171.46 595.724 171.278 595.035 171.778C594.345 172.278 594.214 173.271 594.741 173.996C595.268 174.72 596.254 174.902 596.944 174.402Z"
      fill={$$props.pathColor}
    />
    <path
      d="M619.208 156.965C619.278 156.523 618.976 156.107 618.533 156.037C618.09 155.967 617.674 156.269 617.604 156.711C617.534 157.153 617.836 157.569 618.279 157.639C618.722 157.709 619.138 157.407 619.208 156.965Z"
      fill={$$props.pathColor}
    />
    <path
      d="M471.958 292.735C474.365 291.347 475.154 288.209 473.719 285.728C472.284 283.246 469.169 282.359 466.761 283.747C464.353 285.135 463.564 288.273 464.999 290.754C466.434 293.236 469.55 294.123 471.958 292.735Z"
      fill={$$props.pathColor}
    />
    <path
      d="M511.721 268.938C513.78 267.752 514.449 265.061 513.215 262.928C511.982 260.795 509.314 260.028 507.255 261.215C505.197 262.401 504.528 265.092 505.761 267.225C506.995 269.358 509.663 270.125 511.721 268.938Z"
      fill={$$props.pathColor}
    />
    <path
      d="M453.287 304.172C455.85 302.695 456.692 299.359 455.167 296.722C453.643 294.085 450.329 293.146 447.766 294.623C445.202 296.101 444.361 299.436 445.885 302.073C447.41 304.71 450.724 305.65 453.287 304.172Z"
      fill={$$props.pathColor}
    />
    <path
      d="M491.602 281.194C493.932 279.851 494.694 276.813 493.304 274.409C491.914 272.005 488.898 271.145 486.568 272.488C484.238 273.831 483.476 276.869 484.866 279.273C486.256 281.678 489.272 282.538 491.602 281.194Z"
      fill={$$props.pathColor}
    />
    <path
      d="M553.09 243.723C554.605 242.85 555.106 240.884 554.209 239.333C553.312 237.782 551.357 237.233 549.843 238.106C548.328 238.979 547.827 240.944 548.724 242.495C549.621 244.046 551.576 244.596 553.09 243.723Z"
      fill={$$props.pathColor}
    />
    <path
      d="M531.927 256.439C533.636 255.454 534.185 253.21 533.154 251.426C532.122 249.642 529.901 248.995 528.192 249.98C526.483 250.965 525.934 253.209 526.966 254.993C527.997 256.777 530.218 257.424 531.927 256.439Z"
      fill={$$props.pathColor}
    />
    <path
      d="M573.361 231.165C574.604 230.448 575.011 228.83 574.272 227.55C573.532 226.271 571.924 225.814 570.682 226.53C569.439 227.247 569.031 228.865 569.771 230.145C570.511 231.424 572.118 231.881 573.361 231.165Z"
      fill={$$props.pathColor}
    />
    <path
      d="M594.303 218.47C595.196 217.955 595.484 216.783 594.946 215.853C594.408 214.922 593.247 214.585 592.354 215.1C591.461 215.615 591.173 216.787 591.711 217.717C592.249 218.648 593.41 218.985 594.303 218.47Z"
      fill={$$props.pathColor}
    />
    <path
      d="M616.65 205.172C617.388 204.746 617.622 203.773 617.174 202.997C616.726 202.222 615.764 201.938 615.026 202.363C614.288 202.788 614.053 203.762 614.502 204.538C614.95 205.313 615.912 205.597 616.65 205.172Z"
      fill={$$props.pathColor}
    />
    <path
      d="M480.01 309.864C482.55 308.735 483.663 305.697 482.496 303.079C481.328 300.461 478.323 299.255 475.783 300.384C473.243 301.513 472.13 304.55 473.298 307.168C474.465 309.786 477.47 310.993 480.01 309.864Z"
      fill={$$props.pathColor}
    />
    <path
      d="M521.996 290.324C524.167 289.358 525.114 286.752 524.111 284.502C523.107 282.252 520.534 281.211 518.363 282.176C516.192 283.142 515.245 285.748 516.248 287.998C517.251 290.248 519.824 291.289 521.996 290.324Z"
      fill={$$props.pathColor}
    />
    <path
      d="M460.258 319.305C462.961 318.103 464.148 314.874 462.908 312.092C461.667 309.311 458.47 308.03 455.766 309.232C453.062 310.434 451.876 313.664 453.116 316.445C454.356 319.227 457.554 320.507 460.258 319.305Z"
      fill={$$props.pathColor}
    />
    <path
      d="M500.738 300.328C503.196 299.235 504.272 296.293 503.141 293.757C502.01 291.221 499.101 290.051 496.643 291.143C494.185 292.236 493.109 295.178 494.24 297.714C495.371 300.25 498.28 301.42 500.738 300.328Z"
      fill={$$props.pathColor}
    />
    <path
      d="M565.897 269.539C567.495 268.829 568.199 266.927 567.469 265.29C566.74 263.654 564.853 262.904 563.255 263.614C561.658 264.324 560.954 266.226 561.683 267.863C562.413 269.499 564.3 270.249 565.897 269.539Z"
      fill={$$props.pathColor}
    />
    <path
      d="M543.451 279.959C545.253 279.157 546.034 276.982 545.195 275.101C544.356 273.219 542.215 272.343 540.412 273.145C538.61 273.946 537.829 276.121 538.668 278.003C539.507 279.884 541.648 280.76 543.451 279.959Z"
      fill={$$props.pathColor}
    />
    <path
      d="M587.242 259.233C588.553 258.65 589.128 257.083 588.526 255.733C587.924 254.383 586.373 253.761 585.062 254.344C583.751 254.927 583.177 256.494 583.779 257.844C584.38 259.193 585.931 259.815 587.242 259.233Z"
      fill={$$props.pathColor}
    />
    <path
      d="M609.432 248.739C610.374 248.32 610.783 247.185 610.345 246.203C609.908 245.221 608.789 244.765 607.847 245.184C606.904 245.603 606.495 246.738 606.933 247.72C607.371 248.701 608.49 249.158 609.432 248.739Z"
      fill={$$props.pathColor}
    />
    <path
      d="M486.151 327.69C488.795 326.832 490.219 323.927 489.333 321.202C488.446 318.477 485.583 316.963 482.939 317.82C480.295 318.678 478.87 321.583 479.757 324.309C480.644 327.034 483.506 328.548 486.151 327.69Z"
      fill={$$props.pathColor}
    />
    <path
      d="M529.981 312.633C532.242 311.9 533.456 309.406 532.694 307.064C531.932 304.722 529.482 303.418 527.221 304.151C524.961 304.884 523.746 307.378 524.508 309.72C525.271 312.062 527.721 313.366 529.981 312.633Z"
      fill={$$props.pathColor}
    />
    <path
      d="M465.545 335.024C468.36 334.111 469.878 331.023 468.936 328.127C467.994 325.231 464.948 323.624 462.133 324.537C459.318 325.451 457.8 328.538 458.742 331.434C459.685 334.33 462.73 335.937 465.545 335.024Z"
      fill={$$props.pathColor}
    />
    <path
      d="M507.855 320.528C510.414 319.697 511.792 316.884 510.933 314.244C510.073 311.603 507.302 310.136 504.744 310.966C502.185 311.796 500.807 314.61 501.666 317.25C502.525 319.89 505.296 321.358 507.855 320.528Z"
      fill={$$props.pathColor}
    />
    <path
      d="M575.852 296.582C577.515 296.042 578.414 294.224 577.86 292.52C577.305 290.817 575.508 289.873 573.844 290.413C572.181 290.953 571.282 292.771 571.836 294.474C572.39 296.178 574.188 297.121 575.852 296.582Z"
      fill={$$props.pathColor}
    />
    <path
      d="M552.46 304.676C554.336 304.067 555.341 301.985 554.703 300.026C554.066 298.067 552.028 296.973 550.151 297.582C548.275 298.191 547.27 300.272 547.908 302.231C548.545 304.19 550.583 305.284 552.46 304.676Z"
      fill={$$props.pathColor}
    />
    <path
      d="M598.238 288.557C599.603 288.114 600.339 286.616 599.881 285.211C599.424 283.805 597.947 283.025 596.582 283.468C595.217 283.911 594.482 285.409 594.939 286.814C595.396 288.219 596.873 289 598.238 288.557Z"
      fill={$$props.pathColor}
    />
    <path
      d="M621.344 280.448C622.324 280.13 622.85 279.043 622.517 278.021C622.185 276.999 621.12 276.429 620.139 276.747C619.158 277.065 618.633 278.152 618.965 279.174C619.298 280.196 620.363 280.766 621.344 280.448Z"
      fill={$$props.pathColor}
    />
    <path
      d="M490.472 346.074C493.191 345.497 494.912 342.757 494.316 339.954C493.719 337.15 491.031 335.346 488.311 335.923C485.591 336.5 483.87 339.241 484.467 342.044C485.064 344.847 487.752 346.651 490.472 346.074Z"
      fill={$$props.pathColor}
    />
    <path
      d="M535.621 335.774C537.946 335.28 539.415 332.927 538.902 330.519C538.389 328.11 536.089 326.557 533.764 327.05C531.439 327.544 529.97 329.896 530.483 332.305C530.996 334.714 533.296 336.267 535.621 335.774Z"
      fill={$$props.pathColor}
    />
    <path
      d="M469.182 351.208C472.077 350.593 473.91 347.681 473.276 344.703C472.642 341.724 469.781 339.808 466.886 340.422C463.991 341.037 462.158 343.949 462.792 346.928C463.426 349.906 466.287 351.822 469.182 351.208Z"
      fill={$$props.pathColor}
    />
    <path
      d="M512.745 341.137C515.377 340.578 517.042 337.924 516.464 335.209C515.886 332.493 513.284 330.745 510.652 331.303C508.02 331.862 506.355 334.516 506.933 337.232C507.511 339.947 510.113 341.696 512.745 341.137Z"
      fill={$$props.pathColor}
    />
    <path
      d="M582.853 324.519C584.564 324.156 585.648 322.441 585.275 320.689C584.902 318.937 583.213 317.811 581.503 318.174C579.792 318.537 578.707 320.252 579.08 322.004C579.453 323.756 581.142 324.882 582.853 324.519Z"
      fill={$$props.pathColor}
    />
    <path
      d="M558.789 330.083C560.719 329.673 561.936 327.708 561.507 325.693C561.079 323.678 559.166 322.377 557.236 322.787C555.306 323.196 554.089 325.162 554.518 327.176C554.947 329.191 556.859 330.492 558.789 330.083Z"
      fill={$$props.pathColor}
    />
    <path
      d="M606.009 318.852C607.413 318.554 608.301 317.141 607.994 315.695C607.686 314.25 606.299 313.32 604.895 313.618C603.491 313.916 602.603 315.329 602.911 316.774C603.218 318.22 604.606 319.15 606.009 318.852Z"
      fill={$$props.pathColor}
    />
    <path
      d="M492.854 364.813C495.619 364.523 497.617 361.977 497.317 359.127C497.017 356.277 494.533 354.202 491.768 354.492C489.003 354.783 487.004 357.328 487.304 360.178C487.604 363.028 490.089 365.103 492.854 364.813Z"
      fill={$$props.pathColor}
    />
    <path
      d="M538.791 359.218C541.155 358.97 542.862 356.783 542.604 354.334C542.347 351.885 540.221 350.101 537.858 350.349C535.494 350.597 533.787 352.783 534.045 355.233C534.302 357.682 536.428 359.466 538.791 359.218Z"
      fill={$$props.pathColor}
    />
    <path
      d="M471.113 367.718C474.056 367.409 476.184 364.704 475.865 361.676C475.547 358.648 472.902 356.443 469.959 356.752C467.015 357.061 464.887 359.766 465.206 362.794C465.525 365.823 468.169 368.027 471.113 367.718Z"
      fill={$$props.pathColor}
    />
    <path
      d="M515.613 362.279C518.289 361.998 520.222 359.532 519.932 356.771C519.641 354.011 517.236 352 514.56 352.281C511.885 352.562 509.951 355.027 510.242 357.788C510.532 360.549 512.937 362.56 515.613 362.279Z"
      fill={$$props.pathColor}
    />
    <path
      d="M586.992 353.087C588.732 352.904 589.99 351.312 589.802 349.531C589.615 347.75 588.053 346.454 586.313 346.636C584.574 346.819 583.316 348.411 583.504 350.192C583.691 351.973 585.253 353.269 586.992 353.087Z"
      fill={$$props.pathColor}
    />
    <path
      d="M562.445 356.046C564.407 355.84 565.823 354.013 565.608 351.964C565.392 349.916 563.626 348.422 561.664 348.628C559.702 348.834 558.286 350.662 558.502 352.71C558.717 354.758 560.483 356.252 562.445 356.046Z"
      fill={$$props.pathColor}
    />
    <path
      d="M610.56 349.831C611.987 349.682 613.019 348.369 612.864 346.899C612.71 345.43 611.427 344.36 610 344.51C608.573 344.66 607.541 345.972 607.696 347.442C607.851 348.911 609.133 349.981 610.56 349.831Z"
      fill={$$props.pathColor}
    />
    <path
      d="M493.202 383.726C490.442 383.726 488.168 381.375 488.168 378.537C488.168 375.7 490.442 373.349 493.202 373.349C495.963 373.349 498.236 375.7 498.236 378.537C498.236 381.375 495.963 383.726 493.202 383.726Z"
      fill={$$props.pathColor}
    />
    <path
      d="M539.57 383.003C537.215 383.003 535.266 380.976 535.266 378.544C535.266 376.112 537.215 374.085 539.57 374.085C541.924 374.085 543.873 376.112 543.873 378.544C543.873 380.976 541.924 383.003 539.57 383.003Z"
      fill={$$props.pathColor}
    />
    <path
      d="M471.373 384.289C474.332 384.289 476.732 381.82 476.732 378.776C476.732 375.731 474.332 373.262 471.373 373.262C468.413 373.262 466.014 375.731 466.014 378.776C466.014 381.82 468.413 384.289 471.373 384.289Z"
      fill={$$props.pathColor}
    />
    <path
      d="M516.102 383.488C513.423 383.488 511.23 381.218 511.23 378.461C511.23 375.705 513.423 373.435 516.102 373.435C518.782 373.435 520.974 375.705 520.974 378.461C520.974 381.218 518.782 383.488 516.102 383.488Z"
      fill={$$props.pathColor}
    />
    <path
      d="M588.127 381.869C586.341 381.869 584.96 380.41 584.96 378.626C584.96 376.842 586.422 375.383 588.127 375.383C589.832 375.383 591.294 376.842 591.294 378.626C591.294 380.41 589.832 381.869 588.127 381.869Z"
      fill={$$props.pathColor}
    />
    <path
      d="M563.372 382.279C561.342 382.279 559.799 380.576 559.799 378.55C559.799 376.523 561.423 374.82 563.372 374.82C565.321 374.82 566.945 376.523 566.945 378.55C566.945 380.576 565.321 382.279 563.372 382.279Z"
      fill={$$props.pathColor}
    />
    <path
      d="M611.919 381.058C613.354 381.058 614.517 379.861 614.517 378.383C614.517 376.905 613.354 375.708 611.919 375.708C610.484 375.708 609.321 376.905 609.321 378.383C609.321 379.861 610.484 381.058 611.919 381.058Z"
      fill={$$props.pathColor}
    />
    <path
      d="M131.799 372.137C134.559 372.137 136.833 374.488 136.833 377.326C136.833 380.163 134.559 382.514 131.799 382.514C129.038 382.514 126.764 380.163 126.764 377.326C126.764 374.488 129.038 372.137 131.799 372.137Z"
      fill={$$props.pathColor}
    />
    <path
      d="M85.4404 381.856C87.8171 381.856 89.7438 379.86 89.7438 377.397C89.7438 374.934 87.8171 372.938 85.4404 372.938C83.0637 372.938 81.137 374.934 81.137 377.397C81.137 379.86 83.0637 381.856 85.4404 381.856Z"
      fill={$$props.pathColor}
    />
    <path
      d="M153.628 371.488C156.632 371.488 158.987 374.001 158.987 377.001C158.987 380.001 156.551 382.514 153.628 382.514C150.705 382.514 148.269 380.001 148.269 377.001C148.269 373.92 150.705 371.488 153.628 371.488Z"
      fill={$$props.pathColor}
    />
    <path
      d="M108.985 372.375C111.665 372.375 113.857 374.645 113.857 377.402C113.857 380.158 111.665 382.428 108.985 382.428C106.306 382.428 104.114 380.158 104.114 377.402C104.114 374.645 106.306 372.375 108.985 372.375Z"
      fill={$$props.pathColor}
    />
    <path
      d="M36.8813 380.571C38.6302 380.571 40.048 379.119 40.048 377.328C40.048 375.537 38.6302 374.085 36.8813 374.085C35.1324 374.085 33.7146 375.537 33.7146 377.328C33.7146 379.119 35.1324 380.571 36.8813 380.571Z"
      fill={$$props.pathColor}
    />
    <path
      d="M61.6474 381.132C63.6205 381.132 65.22 379.462 65.22 377.403C65.22 375.343 63.6205 373.673 61.6474 373.673C59.6743 373.673 58.0747 375.343 58.0747 377.403C58.0747 379.462 59.6743 381.132 61.6474 381.132Z"
      fill={$$props.pathColor}
    />
    <path
      d="M13.1642 380.171C14.5992 380.171 15.7625 378.973 15.7625 377.496C15.7625 376.018 14.5992 374.82 13.1642 374.82C11.7292 374.82 10.5659 376.018 10.5659 377.496C10.5659 378.973 11.7292 380.171 13.1642 380.171Z"
      fill={$$props.pathColor}
    />
    <path
      d="M137.841 359.024C138.141 356.174 136.142 353.629 133.377 353.339C130.612 353.048 128.127 355.124 127.827 357.974C127.527 360.824 129.526 363.369 132.291 363.659C135.056 363.95 137.541 361.875 137.841 359.024Z"
      fill={$$props.pathColor}
    />
    <path
      d="M90.9858 354.122C91.2436 351.672 89.5364 349.486 87.1727 349.238C84.809 348.99 82.6838 350.774 82.426 353.223C82.1682 355.672 83.8754 357.859 86.2391 358.107C88.6028 358.355 90.728 356.571 90.9858 354.122Z"
      fill={$$props.pathColor}
    />
    <path
      d="M159.917 361.063C160.236 358.035 158.108 355.33 155.164 355.021C152.221 354.712 149.576 356.917 149.258 359.945C148.939 362.973 151.067 365.678 154.01 365.987C156.954 366.296 159.598 364.092 159.917 361.063Z"
      fill={$$props.pathColor}
    />
    <path
      d="M115.022 356.684C115.313 353.923 113.379 351.457 110.703 351.176C108.027 350.895 105.622 352.906 105.332 355.667C105.041 358.428 106.975 360.893 109.651 361.174C112.326 361.455 114.731 359.445 115.022 356.684Z"
      fill={$$props.pathColor}
    />
    <path
      d="M41.6514 348.818C41.8389 347.036 40.5809 345.444 38.8415 345.262C37.1022 345.079 35.5402 346.375 35.3527 348.157C35.1652 349.938 36.4232 351.53 38.1625 351.712C39.9019 351.895 41.4639 350.599 41.6514 348.818Z"
      fill={$$props.pathColor}
    />
    <path
      d="M66.6106 351.644C66.8262 349.595 65.4103 347.768 63.4479 347.562C61.4856 347.356 59.7201 348.85 59.5044 350.898C59.2888 352.947 60.7048 354.774 62.6671 354.98C64.6294 355.186 66.395 353.692 66.6106 351.644Z"
      fill={$$props.pathColor}
    />
    <path
      d="M17.355 346.537C17.5096 345.068 16.4781 343.755 15.051 343.605C13.6238 343.455 12.3415 344.525 12.1868 345.995C12.0321 347.464 13.0637 348.777 14.4908 348.927C15.918 349.076 17.2003 348.007 17.355 346.537Z"
      fill={$$props.pathColor}
    />
    <path
      d="M140.808 340.908C141.405 338.105 139.684 335.365 136.964 334.788C134.245 334.211 131.556 336.015 130.96 338.818C130.363 341.621 132.084 344.361 134.803 344.939C137.523 345.516 140.211 343.711 140.808 340.908Z"
      fill={$$props.pathColor}
    />
    <path
      d="M94.7469 331.104C95.2597 328.695 93.7908 326.343 91.4661 325.849C89.1413 325.356 86.841 326.909 86.3282 329.317C85.8154 331.726 87.2843 334.079 89.6091 334.573C91.9338 335.066 94.2341 333.513 94.7469 331.104Z"
      fill={$$props.pathColor}
    />
    <path
      d="M162.54 345.227C163.174 342.249 161.341 339.337 158.446 338.722C155.551 338.108 152.69 340.024 152.056 343.002C151.422 345.981 153.255 348.893 156.15 349.508C159.045 350.122 161.906 348.206 162.54 345.227Z"
      fill={$$props.pathColor}
    />
    <path
      d="M118.238 336.152C118.816 333.436 117.151 330.782 114.52 330.223C111.888 329.665 109.286 331.413 108.708 334.129C108.13 336.844 109.794 339.498 112.426 340.057C115.058 340.616 117.66 338.867 118.238 336.152Z"
      fill={$$props.pathColor}
    />
    <path
      d="M46.1449 320.763C46.5178 319.011 45.4334 317.296 43.7227 316.933C42.012 316.57 40.3229 317.696 39.9499 319.448C39.577 321.2 40.6614 322.914 42.3721 323.278C44.0828 323.641 45.7719 322.515 46.1449 320.763Z"
      fill={$$props.pathColor}
    />
    <path
      d="M70.7086 326.018C71.1375 324.003 69.9206 322.037 67.9906 321.628C66.0606 321.218 64.1483 322.519 63.7194 324.534C63.2906 326.549 64.5074 328.514 66.4375 328.924C68.3675 329.333 70.2798 328.032 70.7086 326.018Z"
      fill={$$props.pathColor}
    />
    <path
      d="M22.2639 315.887C22.5716 314.442 21.6831 313.029 20.2795 312.731C18.8759 312.433 17.4886 313.363 17.1809 314.809C16.8732 316.254 17.7617 317.667 19.1653 317.965C20.5689 318.263 21.9562 317.333 22.2639 315.887Z"
      fill={$$props.pathColor}
    />
    <path
      d="M145.605 323.216C146.491 320.49 145.067 317.585 142.423 316.728C139.778 315.87 136.916 317.384 136.029 320.109C135.142 322.835 136.567 325.739 139.211 326.597C141.855 327.455 144.718 325.941 145.605 323.216Z"
      fill={$$props.pathColor}
    />
    <path
      d="M100.871 308.742C101.633 306.399 100.418 303.906 98.1578 303.173C95.8974 302.44 93.4471 303.744 92.685 306.086C91.9228 308.428 93.1373 310.921 95.3977 311.655C97.6581 312.388 100.108 311.084 100.871 308.742Z"
      fill={$$props.pathColor}
    />
    <path
      d="M166.81 329.838C167.752 326.942 166.234 323.854 163.419 322.941C160.604 322.028 157.559 323.635 156.616 326.531C155.674 329.426 157.192 332.514 160.007 333.427C162.822 334.341 165.867 332.734 166.81 329.838Z"
      fill={$$props.pathColor}
    />
    <path
      d="M123.741 316.041C124.6 313.401 123.222 310.587 120.663 309.757C118.104 308.927 115.334 310.394 114.474 313.035C113.615 315.675 114.993 318.488 117.552 319.318C120.111 320.149 122.882 318.681 123.741 316.041Z"
      fill={$$props.pathColor}
    />
    <path
      d="M53.5488 293.29C54.1031 291.587 53.204 289.768 51.5407 289.229C49.8774 288.689 48.0797 289.632 47.5254 291.336C46.9711 293.039 47.8701 294.858 49.5334 295.397C51.1967 295.937 52.9945 294.993 53.5488 293.29Z"
      fill={$$props.pathColor}
    />
    <path
      d="M77.4481 301.064C78.0855 299.105 77.081 297.023 75.2045 296.415C73.3279 295.806 71.2899 296.9 70.6525 298.859C70.015 300.818 71.0195 302.9 72.8961 303.508C74.7726 304.117 76.8106 303.023 77.4481 301.064Z"
      fill={$$props.pathColor}
    />
    <path
      d="M30.4412 285.905C30.8985 284.499 30.1628 283.001 28.7981 282.558C27.4333 282.116 25.9562 282.896 25.4989 284.301C25.0416 285.706 25.7773 287.205 27.142 287.647C28.5068 288.09 29.9839 287.31 30.4412 285.905Z"
      fill={$$props.pathColor}
    />
    <path
      d="M6.36977 277.923C6.70235 276.901 6.17676 275.815 5.19584 275.496C4.21491 275.178 3.1501 275.749 2.81752 276.771C2.48494 277.793 3.01053 278.879 3.99146 279.198C4.97239 279.516 6.03719 278.945 6.36977 277.923Z"
      fill={$$props.pathColor}
    />
    <path
      d="M152.225 306.062C153.393 303.444 152.28 300.406 149.74 299.277C147.2 298.148 144.195 299.355 143.027 301.973C141.86 304.591 142.973 307.629 145.513 308.758C148.053 309.887 151.058 308.68 152.225 306.062Z"
      fill={$$props.pathColor}
    />
    <path
      d="M109.271 286.917C110.274 284.667 109.327 282.061 107.156 281.095C104.985 280.13 102.411 281.171 101.408 283.421C100.405 285.671 101.352 288.277 103.523 289.243C105.694 290.208 108.268 289.167 109.271 286.917Z"
      fill={$$props.pathColor}
    />
    <path
      d="M172.638 314.816C173.878 312.034 172.692 308.805 169.988 307.603C167.284 306.401 164.087 307.681 162.846 310.463C161.606 313.245 162.792 316.474 165.496 317.676C168.2 318.878 171.397 317.597 172.638 314.816Z"
      fill={$$props.pathColor}
    />
    <path
      d="M131.158 296.75C132.289 294.214 131.213 291.272 128.755 290.179C126.297 289.086 123.387 290.257 122.257 292.793C121.126 295.329 122.202 298.271 124.66 299.363C127.118 300.456 130.027 299.286 131.158 296.75Z"
      fill={$$props.pathColor}
    />
    <path
      d="M63.884 266.717C64.6136 265.081 63.9098 263.178 62.3121 262.468C60.7144 261.758 58.8277 262.509 58.0981 264.145C57.3685 265.781 58.0723 267.683 59.67 268.394C61.2677 269.104 63.1544 268.353 63.884 266.717Z"
      fill={$$props.pathColor}
    />
    <path
      d="M86.7828 276.969C87.6219 275.088 86.8408 272.913 85.0382 272.111C83.2357 271.31 81.0943 272.186 80.2553 274.068C79.4163 275.949 80.1973 278.124 81.9999 278.926C83.8024 279.727 85.9438 278.851 86.7828 276.969Z"
      fill={$$props.pathColor}
    />
    <path
      d="M41.6284 256.949C42.2304 255.599 41.6556 254.032 40.3446 253.449C39.0337 252.867 37.483 253.488 36.8811 254.838C36.2792 256.188 36.854 257.755 38.1649 258.338C39.4759 258.921 41.0265 258.299 41.6284 256.949Z"
      fill={$$props.pathColor}
    />
    <path
      d="M18.5788 246.612C19.0165 245.63 18.6076 244.495 17.6653 244.076C16.7231 243.657 15.6044 244.113 15.1666 245.095C14.7289 246.077 15.1379 247.212 16.0801 247.631C17.0223 248.05 18.141 247.594 18.5788 246.612Z"
      fill={$$props.pathColor}
    />
    <path
      d="M160.712 289.716C162.147 287.234 161.358 284.097 158.951 282.709C156.543 281.321 153.428 282.207 151.993 284.689C150.558 287.171 151.346 290.308 153.754 291.696C156.162 293.084 159.277 292.197 160.712 289.716Z"
      fill={$$props.pathColor}
    />
    <path
      d="M119.858 266.288C121.091 264.155 120.422 261.464 118.364 260.278C116.306 259.091 113.637 259.858 112.404 261.991C111.171 264.124 111.84 266.814 113.898 268.001C115.956 269.188 118.625 268.421 119.858 266.288Z"
      fill={$$props.pathColor}
    />
    <path
      d="M179.978 300.559C181.503 297.922 180.661 294.586 178.097 293.109C175.534 291.631 172.22 292.571 170.696 295.208C169.171 297.845 170.013 301.18 172.576 302.658C175.139 304.135 178.453 303.196 179.978 300.559Z"
      fill={$$props.pathColor}
    />
    <path
      d="M140.749 278.267C142.139 275.863 141.377 272.825 139.047 271.482C136.716 270.138 133.7 270.998 132.31 273.403C130.92 275.807 131.682 278.845 134.012 280.188C136.343 281.531 139.358 280.671 140.749 278.267Z"
      fill={$$props.pathColor}
    />
    <path
      d="M76.9535 241.339C77.8504 239.788 77.3496 237.823 75.835 236.95C74.3204 236.077 72.3655 236.626 71.4687 238.178C70.5718 239.729 71.0725 241.694 72.5872 242.567C74.1018 243.44 76.0566 242.891 76.9535 241.339Z"
      fill={$$props.pathColor}
    />
    <path
      d="M98.6466 254.005C99.678 252.221 99.1289 249.977 97.4202 248.992C95.7114 248.006 93.49 248.654 92.4586 250.438C91.4272 252.221 91.9763 254.466 93.6851 255.451C95.3939 256.436 97.6152 255.789 98.6466 254.005Z"
      fill={$$props.pathColor}
    />
    <path
      d="M55.7803 229.338C56.5203 228.058 56.1126 226.44 54.8699 225.724C53.6271 225.007 52.0199 225.464 51.2799 226.744C50.54 228.023 50.9476 229.641 52.1904 230.358C53.4331 231.074 55.0404 230.618 55.7803 229.338Z"
      fill={$$props.pathColor}
    />
    <path
      d="M33.8343 216.601C34.3724 215.671 34.0845 214.499 33.1913 213.984C32.2981 213.469 31.1377 213.806 30.5996 214.737C30.0615 215.667 30.3493 216.839 31.2426 217.354C32.1358 217.869 33.2961 217.532 33.8343 216.601Z"
      fill={$$props.pathColor}
    />
    <path
      d="M11.0642 203.465C11.5126 202.689 11.278 201.716 10.5401 201.29C9.80219 200.865 8.84049 201.149 8.39205 201.924C7.94361 202.7 8.17825 203.673 8.91614 204.099C9.65402 204.524 10.6157 204.24 11.0642 203.465Z"
      fill={$$props.pathColor}
    />
    <path
      d="M170.762 274.403C172.449 272.085 171.993 268.882 169.744 267.251C167.495 265.619 164.304 266.175 162.617 268.494C160.93 270.812 161.386 274.014 163.635 275.646C165.884 277.278 169.075 276.721 170.762 274.403Z"
      fill={$$props.pathColor}
    />
    <path
      d="M132.61 246.758C134.06 244.765 133.676 242.02 131.753 240.625C129.83 239.23 127.096 239.714 125.647 241.706C124.197 243.699 124.58 246.445 126.503 247.84C128.426 249.235 131.16 248.75 132.61 246.758Z"
      fill={$$props.pathColor}
    />
    <path
      d="M188.851 287.183C190.643 284.719 190.155 281.314 187.761 279.577C185.366 277.84 181.972 278.429 180.18 280.892C178.387 283.355 178.875 286.76 181.27 288.498C183.664 290.235 187.058 289.646 188.851 287.183Z"
      fill={$$props.pathColor}
    />
    <path
      d="M152.123 260.861C153.757 258.615 153.317 255.514 151.14 253.935C148.963 252.356 145.874 252.896 144.24 255.142C142.606 257.388 143.045 260.489 145.222 262.068C147.399 263.647 150.488 263.107 152.123 260.861Z"
      fill={$$props.pathColor}
    />
    <path
      d="M92.4325 217.538C93.4869 216.089 93.1946 214.082 91.7797 213.055C90.3648 212.029 88.3631 212.371 87.3087 213.82C86.2544 215.269 86.5467 217.276 87.9616 218.303C89.3765 219.329 91.3782 218.987 92.4325 217.538Z"
      fill={$$props.pathColor}
    />
    <path
      d="M112.738 232.336C113.951 230.67 113.64 228.38 112.043 227.222C110.447 226.064 108.17 226.476 106.958 228.143C105.745 229.809 106.056 232.099 107.653 233.257C109.249 234.415 111.526 234.003 112.738 232.336Z"
      fill={$$props.pathColor}
    />
    <path
      d="M72.681 203.392C73.5508 202.196 73.3148 200.544 72.1539 199.702C70.9929 198.86 69.3467 199.146 68.4768 200.342C67.607 201.537 67.843 203.189 69.0039 204.031C70.1649 204.874 71.8111 204.587 72.681 203.392Z"
      fill={$$props.pathColor}
    />
    <path
      d="M52.3332 188.342C52.9658 187.473 52.8022 186.277 51.9677 185.672C51.1333 185.066 49.9441 185.281 49.3115 186.15C48.6788 187.019 48.8424 188.215 49.6769 188.82C50.5113 189.426 51.7006 189.211 52.3332 188.342Z"
      fill={$$props.pathColor}
    />
    <path
      d="M30.9563 172.987C31.4835 172.263 31.3521 171.27 30.6628 170.77C29.9735 170.27 28.9873 170.452 28.4601 171.176C27.933 171.901 28.0644 172.894 28.7537 173.394C29.443 173.894 30.4292 173.712 30.9563 172.987Z"
      fill={$$props.pathColor}
    />
    <path
      d="M7.48985 156.563C7.93276 156.493 8.23495 156.077 8.1648 155.635C8.09465 155.193 7.67873 154.891 7.23581 154.961C6.79289 155.031 6.4907 155.446 6.56086 155.889C6.63101 156.331 7.04693 156.633 7.48985 156.563Z"
      fill={$$props.pathColor}
    />
    <path
      d="M182.313 260.11C184.233 257.981 184.115 254.749 182.049 252.891C179.983 251.033 176.751 251.254 174.83 253.383C172.91 255.513 173.028 258.745 175.094 260.603C177.161 262.461 180.392 262.24 182.313 260.11Z"
      fill={$$props.pathColor}
    />
    <path
      d="M147.377 228.685C149.027 226.855 148.933 224.084 147.167 222.496C145.401 220.908 142.631 221.104 140.981 222.934C139.331 224.764 139.425 227.535 141.191 229.123C142.957 230.711 145.727 230.515 147.377 228.685Z"
      fill={$$props.pathColor}
    />
    <path
      d="M199.043 274.781C201.084 272.518 200.955 269.081 198.755 267.103C196.556 265.126 193.119 265.357 191.078 267.62C189.038 269.883 189.167 273.32 191.366 275.298C193.566 277.275 197.003 277.044 199.043 274.781Z"
      fill={$$props.pathColor}
    />
    <path
      d="M165.24 244.799C167.1 242.736 166.987 239.606 164.988 237.809C162.988 236.011 159.859 236.226 157.999 238.289C156.138 240.352 156.251 243.482 158.251 245.28C160.25 247.077 163.379 246.862 165.24 244.799Z"
      fill={$$props.pathColor}
    />
    <path
      d="M110.388 195.389C111.588 194.058 111.507 192.032 110.208 190.863C108.908 189.695 106.881 189.827 105.681 191.158C104.481 192.489 104.561 194.515 105.861 195.683C107.161 196.852 109.187 196.72 110.388 195.389Z"
      fill={$$props.pathColor}
    />
    <path
      d="M129.079 212.299C130.459 210.769 130.389 208.459 128.923 207.141C127.456 205.822 125.149 205.995 123.769 207.525C122.388 209.056 122.458 211.366 123.924 212.684C125.391 214.002 127.698 213.83 129.079 212.299Z"
      fill={$$props.pathColor}
    />
    <path
      d="M92.2659 179.297C93.2561 178.199 93.1943 176.531 92.1279 175.572C91.0615 174.614 89.3942 174.727 88.404 175.825C87.4138 176.923 87.4756 178.59 88.542 179.549C89.6084 180.508 91.2756 180.395 92.2659 179.297Z"
      fill={$$props.pathColor}
    />
    <path
      d="M73.5557 162.262C74.2759 161.464 74.2383 160.258 73.4718 159.569C72.7053 158.88 71.5002 158.968 70.78 159.767C70.0599 160.565 70.0974 161.772 70.8639 162.461C71.6304 163.15 72.8356 163.061 73.5557 162.262Z"
      fill={$$props.pathColor}
    />
    <path
      d="M54.0559 144.669C54.656 144.003 54.6292 143.002 53.996 142.433C53.3628 141.864 52.363 141.942 51.7629 142.607C51.1628 143.273 51.1896 144.274 51.8227 144.843C52.4559 145.413 53.4557 145.334 54.0559 144.669Z"
      fill={$$props.pathColor}
    />
    <path
      d="M32.2955 125.869C32.7433 125.845 33.0873 125.464 33.0639 125.017C33.0404 124.569 32.6583 124.226 32.2105 124.249C31.7627 124.273 31.4187 124.654 31.4422 125.101C31.4656 125.549 31.8477 125.892 32.2955 125.869Z"
      fill={$$props.pathColor}
    />
    <path
      d="M195.43 247.214C197.563 245.296 197.784 242.069 195.924 240.006C194.063 237.943 190.826 237.825 188.693 239.743C186.561 241.66 186.34 244.887 188.2 246.95C190.06 249.013 193.298 249.131 195.43 247.214Z"
      fill={$$props.pathColor}
    />
    <path
      d="M163.945 212.271C165.778 210.624 165.975 207.858 164.384 206.094C162.794 204.331 160.019 204.237 158.186 205.885C156.353 207.533 156.156 210.298 157.747 212.062C159.337 213.826 162.112 213.919 163.945 212.271Z"
      fill={$$props.pathColor}
    />
    <path
      d="M210.536 263.494C212.802 261.456 213.033 258.024 211.053 255.828C209.073 253.632 205.63 253.503 203.364 255.541C201.098 257.578 200.866 261.01 202.847 263.206C204.827 265.402 208.27 265.531 210.536 263.494Z"
      fill={$$props.pathColor}
    />
    <path
      d="M179.948 230.158C182.014 228.3 182.23 225.176 180.429 223.179C178.629 221.183 175.495 221.07 173.428 222.928C171.362 224.785 171.147 227.91 172.947 229.906C174.748 231.903 177.882 232.015 179.948 230.158Z"
      fill={$$props.pathColor}
    />
    <path
      d="M130.711 175.342C132.044 174.144 132.176 172.12 131.006 170.823C129.836 169.525 127.806 169.444 126.473 170.643C125.14 171.841 125.008 173.865 126.179 175.163C127.349 176.46 129.378 176.541 130.711 175.342Z"
      fill={$$props.pathColor}
    />
    <path
      d="M147.453 194.103C148.986 192.724 149.158 190.42 147.838 188.956C146.518 187.492 144.205 187.422 142.672 188.801C141.139 190.179 140.966 192.483 142.287 193.947C143.607 195.411 145.92 195.481 147.453 194.103Z"
      fill={$$props.pathColor}
    />
    <path
      d="M114.341 157.435C115.441 156.446 115.554 154.782 114.594 153.717C113.633 152.652 111.964 152.59 110.864 153.579C109.764 154.568 109.651 156.233 110.611 157.297C111.571 158.362 113.241 158.424 114.341 157.435Z"
      fill={$$props.pathColor}
    />
    <path
      d="M97.4814 138.53C98.2812 137.811 98.3701 136.608 97.6799 135.842C96.9898 135.077 95.7819 135.039 94.9821 135.759C94.1823 136.478 94.0934 137.681 94.7836 138.446C95.4737 139.212 96.6815 139.249 97.4814 138.53Z"
      fill={$$props.pathColor}
    />
    <path
      d="M79.8657 119.025C80.5322 118.426 80.6103 117.427 80.0402 116.795C79.4701 116.163 78.4676 116.136 77.8011 116.735C77.1346 117.335 77.0564 118.333 77.6265 118.965C78.1967 119.597 79.1991 119.624 79.8657 119.025Z"
      fill={$$props.pathColor}
    />
    <path
      d="M61.2249 97.329C61.2507 96.8371 60.8723 96.4175 60.3797 96.3917C59.8871 96.3659 59.4668 96.7437 59.441 97.2356C59.4152 97.7275 59.7936 98.1471 60.2862 98.1729C60.7788 98.1987 61.1991 97.8208 61.2249 97.329Z"
      fill={$$props.pathColor}
    />
    <path
      d="M209.686 235.703C212.008 234.018 212.566 230.832 210.932 228.586C209.297 226.34 206.09 225.885 203.768 227.569C201.446 229.254 200.889 232.44 202.523 234.686C204.157 236.932 207.365 237.387 209.686 235.703Z"
      fill={$$props.pathColor}
    />
    <path
      d="M182.08 197.662C184.075 196.214 184.56 193.485 183.163 191.565C181.766 189.645 179.016 189.262 177.021 190.709C175.026 192.157 174.54 194.887 175.937 196.807C177.334 198.727 180.085 199.11 182.08 197.662Z"
      fill={$$props.pathColor}
    />
    <path
      d="M222.965 253.48C225.432 251.69 226.022 248.301 224.282 245.91C222.542 243.52 219.132 243.032 216.665 244.822C214.198 246.612 213.609 250.001 215.348 252.392C217.088 254.782 220.498 255.27 222.965 253.48Z"
      fill={$$props.pathColor}
    />
    <path
      d="M196.145 217.031C198.395 215.4 198.936 212.315 197.355 210.141C195.773 207.968 192.668 207.529 190.418 209.16C188.169 210.792 187.628 213.877 189.209 216.05C190.791 218.224 193.896 218.663 196.145 217.031Z"
      fill={$$props.pathColor}
    />
    <path
      d="M152.889 157.476C154.34 156.423 154.683 154.424 153.655 153.011C152.627 151.599 150.617 151.307 149.166 152.359C147.715 153.412 147.372 155.411 148.4 156.824C149.428 158.236 151.438 158.528 152.889 157.476Z"
      fill={$$props.pathColor}
    />
    <path
      d="M167.584 177.865C169.253 176.655 169.666 174.381 168.506 172.787C167.346 171.193 165.053 170.883 163.384 172.093C161.715 173.304 161.302 175.578 162.462 177.171C163.622 178.765 165.915 179.076 167.584 177.865Z"
      fill={$$props.pathColor}
    />
    <path
      d="M138.455 137.911C139.652 137.042 139.939 135.399 139.095 134.239C138.252 133.08 136.598 132.845 135.4 133.713C134.203 134.582 133.916 136.225 134.76 137.385C135.603 138.544 137.258 138.779 138.455 137.911Z"
      fill={$$props.pathColor}
    />
    <path
      d="M123.656 117.335C124.527 116.703 124.742 115.516 124.135 114.683C123.529 113.849 122.332 113.686 121.461 114.318C120.59 114.949 120.376 116.137 120.982 116.97C121.588 117.803 122.786 117.967 123.656 117.335Z"
      fill={$$props.pathColor}
    />
    <path
      d="M108.257 96.0738C108.983 95.5474 109.165 94.5627 108.664 93.8745C108.163 93.1862 107.169 93.0549 106.443 93.5813C105.718 94.1077 105.536 95.0924 106.036 95.7807C106.537 96.4689 107.531 96.6002 108.257 96.0738Z"
      fill={$$props.pathColor}
    />
    <path
      d="M91.8894 72.5928C91.9666 72.1063 91.6342 71.6494 91.147 71.5724C90.6598 71.4953 90.2022 71.8272 90.1251 72.3137C90.0479 72.8002 90.3803 73.257 90.8675 73.3341C91.3547 73.4111 91.8123 73.0792 91.8894 72.5928Z"
      fill={$$props.pathColor}
    />
    <path
      d="M225.195 225.737C227.68 224.304 228.568 221.194 227.178 218.79C225.788 216.385 222.646 215.598 220.16 217.031C217.675 218.464 216.787 221.574 218.177 223.978C219.567 226.383 222.709 227.17 225.195 225.737Z"
      fill={$$props.pathColor}
    />
    <path
      d="M201.656 184.952C203.792 183.721 204.56 181.057 203.371 179.001C202.183 176.946 199.488 176.278 197.352 177.51C195.216 178.741 194.448 181.405 195.636 183.461C196.825 185.516 199.52 186.184 201.656 184.952Z"
      fill={$$props.pathColor}
    />
    <path
      d="M236.553 244.749C239.194 243.227 240.135 239.918 238.655 237.359C237.176 234.799 233.835 233.959 231.194 235.481C228.553 237.003 227.612 240.312 229.092 242.872C230.572 245.431 233.912 246.272 236.553 244.749Z"
      fill={$$props.pathColor}
    />
    <path
      d="M213.642 205.821C216.05 204.433 216.911 201.422 215.566 199.095C214.221 196.768 211.178 196.008 208.77 197.396C206.363 198.784 205.501 201.795 206.847 204.122C208.192 206.448 211.234 207.209 213.642 205.821Z"
      fill={$$props.pathColor}
    />
    <path
      d="M176.813 142.063C178.367 141.167 178.917 139.215 178.043 137.703C177.168 136.19 175.2 135.69 173.646 136.586C172.093 137.482 171.543 139.434 172.417 140.946C173.292 142.458 175.26 142.958 176.813 142.063Z"
      fill={$$props.pathColor}
    />
    <path
      d="M189.324 163.774C191.11 162.744 191.759 160.526 190.772 158.82C189.786 157.114 187.538 156.566 185.751 157.595C183.965 158.625 183.316 160.843 184.303 162.55C185.29 164.256 187.537 164.804 189.324 163.774Z"
      fill={$$props.pathColor}
    />
    <path
      d="M164.503 121.106C165.785 120.368 166.242 118.763 165.525 117.522C164.807 116.281 163.187 115.874 161.905 116.613C160.623 117.352 160.166 118.956 160.884 120.197C161.601 121.438 163.222 121.845 164.503 121.106Z"
      fill={$$props.pathColor}
    />
    <path
      d="M152.083 99.128C153.015 98.5907 153.353 97.4321 152.837 96.5402C152.321 95.6483 151.148 95.3609 150.216 95.8982C149.284 96.4355 148.946 97.5941 149.462 98.486C149.978 99.3779 151.151 99.6653 152.083 99.128Z"
      fill={$$props.pathColor}
    />
    <path
      d="M138.8 76.372C139.577 75.9242 139.861 74.964 139.435 74.2272C139.009 73.4904 138.034 73.2561 137.257 73.7039C136.481 74.1517 136.196 75.1119 136.622 75.8487C137.048 76.5855 138.023 76.8198 138.8 76.372Z"
      fill={$$props.pathColor}
    />
    <path
      d="M125.108 51.3048C125.236 50.829 124.953 50.34 124.477 50.2125C124 50.085 123.511 50.3674 123.383 50.8431C123.255 51.3189 123.538 51.8079 124.015 51.9354C124.491 52.0629 124.981 51.7805 125.108 51.3048Z"
      fill={$$props.pathColor}
    />
    <path
      d="M241.529 217.371C244.151 216.205 245.36 213.204 244.229 210.668C243.098 208.132 240.056 207.021 237.434 208.186C234.812 209.352 233.603 212.353 234.734 214.889C235.865 217.425 238.907 218.536 241.529 217.371Z"
      fill={$$props.pathColor}
    />
    <path
      d="M222.418 174.5C224.672 173.498 225.714 170.929 224.748 168.761C223.781 166.593 221.171 165.647 218.918 166.649C216.664 167.651 215.622 170.22 216.588 172.388C217.555 174.556 220.165 175.502 222.418 174.5Z"
      fill={$$props.pathColor}
    />
    <path
      d="M250.917 237.612C253.703 236.374 254.986 233.181 253.782 230.482C252.578 227.782 249.344 226.597 246.558 227.836C243.772 229.074 242.49 232.267 243.694 234.966C244.897 237.666 248.132 238.851 250.917 237.612Z"
      fill={$$props.pathColor}
    />
    <path
      d="M232.205 196.538C234.745 195.409 235.917 192.504 234.823 190.049C233.728 187.595 230.782 186.521 228.242 187.65C225.702 188.779 224.53 191.684 225.625 194.138C226.719 196.593 229.665 197.667 232.205 196.538Z"
      fill={$$props.pathColor}
    />
    <path
      d="M202.273 129.118C203.912 128.389 204.663 126.505 203.952 124.91C203.241 123.315 201.336 122.612 199.697 123.34C198.058 124.069 197.306 125.953 198.018 127.548C198.729 129.143 200.634 129.846 202.273 129.118Z"
      fill={$$props.pathColor}
    />
    <path
      d="M212.416 152.103C214.301 151.265 215.178 149.127 214.375 147.327C213.573 145.527 211.394 144.747 209.51 145.585C207.625 146.423 206.748 148.561 207.551 150.361C208.353 152.161 210.532 152.941 212.416 152.103Z"
      fill={$$props.pathColor}
    />
    <path
      d="M192.227 107.059C193.578 106.458 194.201 104.909 193.618 103.6C193.034 102.291 191.465 101.718 190.113 102.319C188.761 102.92 188.138 104.468 188.722 105.777C189.306 107.086 190.875 107.66 192.227 107.059Z"
      fill={$$props.pathColor}
    />
    <path
      d="M182.094 83.9474C183.077 83.5103 183.534 82.3933 183.115 81.4524C182.695 80.5116 181.558 80.1033 180.575 80.5404C179.592 80.9775 179.135 82.0945 179.554 83.0353C179.974 83.9761 181.111 84.3845 182.094 83.9474Z"
      fill={$$props.pathColor}
    />
    <path
      d="M171.408 59.8322C172.228 59.468 172.611 58.5426 172.265 57.7654C171.918 56.9882 170.973 56.6535 170.153 57.0177C169.334 57.382 168.951 58.3073 169.297 59.0845C169.644 59.8617 170.589 60.1965 171.408 59.8322Z"
      fill={$$props.pathColor}
    />
    <path
      d="M160.316 33.4829C160.493 33.023 160.263 32.5072 159.803 32.3307C159.342 32.1542 158.825 32.3838 158.649 32.8437C158.472 33.3035 158.702 33.8194 159.162 33.9959C159.623 34.1724 160.14 33.9427 160.316 33.4829Z"
      fill={$$props.pathColor}
    />
    <path
      d="M258.805 210.983C261.535 210.097 263.051 207.239 262.192 204.599C261.333 201.959 258.424 200.536 255.694 201.422C252.964 202.307 251.448 205.166 252.307 207.806C253.167 210.446 256.076 211.869 258.805 210.983Z"
      fill={$$props.pathColor}
    />
    <path
      d="M244.201 166.212C246.547 165.451 247.853 163.005 247.119 160.748C246.384 158.491 243.887 157.278 241.542 158.039C239.196 158.8 237.89 161.247 238.624 163.504C239.359 165.761 241.856 166.973 244.201 166.212Z"
      fill={$$props.pathColor}
    />
    <path
      d="M265.848 231.973C268.748 231.032 270.358 227.991 269.443 225.18C268.529 222.37 265.436 220.854 262.536 221.795C259.636 222.736 258.027 225.777 258.941 228.588C259.856 231.398 262.948 232.914 265.848 231.973Z"
      fill={$$props.pathColor}
    />
    <path
      d="M251.649 189.104C254.293 188.246 255.762 185.48 254.931 182.925C254.1 180.369 251.282 178.994 248.638 179.851C245.993 180.709 244.524 183.476 245.355 186.031C246.187 188.586 249.004 189.962 251.649 189.104Z"
      fill={$$props.pathColor}
    />
    <path
      d="M228.927 119.045C230.633 118.492 231.578 116.697 231.038 115.036C230.497 113.375 228.676 112.477 226.97 113.031C225.264 113.584 224.319 115.379 224.86 117.04C225.4 118.701 227.221 119.599 228.927 119.045Z"
      fill={$$props.pathColor}
    />
    <path
      d="M236.673 142.932C238.634 142.296 239.731 140.261 239.121 138.387C238.511 136.513 236.426 135.51 234.465 136.147C232.503 136.783 231.407 138.818 232.016 140.692C232.626 142.566 234.711 143.569 236.673 142.932Z"
      fill={$$props.pathColor}
    />
    <path
      d="M221.242 95.9802C222.649 95.5236 223.431 94.0487 222.987 92.686C222.544 91.3232 221.043 90.5887 219.636 91.0453C218.229 91.5019 217.447 92.9768 217.891 94.3395C218.334 95.7022 219.834 96.4368 221.242 95.9802Z"
      fill={$$props.pathColor}
    />
    <path
      d="M213.584 71.8983C214.608 71.5662 215.179 70.503 214.86 69.5235C214.541 68.5441 213.453 68.0193 212.43 68.3513C211.406 68.6834 210.835 69.7466 211.154 70.7261C211.472 71.7056 212.56 72.2304 213.584 71.8983Z"
      fill={$$props.pathColor}
    />
    <path
      d="M205.416 46.9048C206.269 46.6281 206.747 45.7478 206.483 44.9387C206.22 44.1296 205.315 43.698 204.462 43.9748C203.609 44.2515 203.131 45.1318 203.394 45.9409C203.658 46.75 204.563 47.1816 205.416 46.9048Z"
      fill={$$props.pathColor}
    />
    <path
      d="M197.278 19.4941C197.502 19.0553 197.327 18.5182 196.888 18.2946C196.448 18.071 195.91 18.2455 195.686 18.6844C195.462 19.1232 195.637 19.6603 196.077 19.8839C196.516 20.1075 197.054 19.933 197.278 19.4941Z"
      fill={$$props.pathColor}
    />
    <path
      d="M276.598 206.24C279.405 205.644 281.212 202.96 280.634 200.244C280.056 197.529 277.312 195.81 274.504 196.406C271.697 197.002 269.89 199.686 270.468 202.402C271.046 205.117 273.791 206.836 276.598 206.24Z"
      fill={$$props.pathColor}
    />
    <path
      d="M266.731 160.296C269.143 159.783 270.699 157.487 270.204 155.165C269.71 152.844 267.354 151.377 264.941 151.889C262.529 152.401 260.974 154.698 261.468 157.02C261.962 159.341 264.318 160.808 266.731 160.296Z"
      fill={$$props.pathColor}
    />
    <path
      d="M281.399 227.886C284.382 227.253 286.301 224.397 285.686 221.506C285.07 218.615 282.154 216.785 279.171 217.418C276.188 218.051 274.269 220.908 274.884 223.798C275.5 226.689 278.416 228.519 281.399 227.886Z"
      fill={$$props.pathColor}
    />
    <path
      d="M271.786 183.816C274.505 183.239 276.256 180.641 275.697 178.013C275.138 175.385 272.479 173.723 269.76 174.3C267.04 174.877 265.289 177.475 265.849 180.103C266.408 182.731 269.066 184.394 271.786 183.816Z"
      fill={$$props.pathColor}
    />
    <path
      d="M256.521 111.711C258.276 111.339 259.403 109.652 259.04 107.944C258.676 106.236 256.959 105.153 255.204 105.525C253.45 105.898 252.322 107.584 252.686 109.292C253.049 111 254.766 112.083 256.521 111.711Z"
      fill={$$props.pathColor}
    />
    <path
      d="M261.602 136.317C263.62 135.888 264.923 133.979 264.513 132.052C264.102 130.125 262.134 128.91 260.116 129.338C258.099 129.766 256.795 131.676 257.206 133.603C257.616 135.53 259.584 136.745 261.602 136.317Z"
      fill={$$props.pathColor}
    />
    <path
      d="M251.294 87.9933C252.742 87.6861 253.673 86.3009 253.375 84.8993C253.077 83.4978 251.661 82.6106 250.214 82.9179C248.766 83.2251 247.835 84.6103 248.133 86.0118C248.431 87.4134 249.847 88.3005 251.294 87.9933Z"
      fill={$$props.pathColor}
    />
    <path
      d="M246.165 63.2795C247.218 63.0561 247.897 62.0584 247.683 61.051C247.469 60.0436 246.441 59.4081 245.389 59.6316C244.336 59.855 243.656 60.8528 243.871 61.8601C244.085 62.8675 245.112 63.503 246.165 63.2795Z"
      fill={$$props.pathColor}
    />
    <path
      d="M240.671 37.4994C241.548 37.3132 242.116 36.4877 241.939 35.6555C241.761 34.8233 240.907 34.2997 240.029 34.4859C239.152 34.6721 238.585 35.4976 238.762 36.3298C238.939 37.1619 239.794 37.6856 240.671 37.4994Z"
      fill={$$props.pathColor}
    />
    <path
      d="M235.299 9.42271C235.568 9.00963 235.45 8.45729 235.036 8.18903C234.623 7.92077 234.07 8.03818 233.801 8.45126C233.532 8.86435 233.65 9.41669 234.064 9.68494C234.477 9.9532 235.03 9.8358 235.299 9.42271Z"
      fill={$$props.pathColor}
    />
    <path
      d="M294.68 203.392C297.535 203.093 299.613 200.612 299.322 197.851C299.032 195.09 296.482 193.094 293.628 193.394C290.774 193.693 288.695 196.174 288.986 198.935C289.277 201.696 291.826 203.692 294.68 203.392Z"
      fill={$$props.pathColor}
    />
    <path
      d="M289.734 156.72C292.187 156.463 293.974 154.341 293.725 151.981C293.477 149.621 291.287 147.916 288.834 148.174C286.381 148.431 284.594 150.553 284.842 152.913C285.091 155.273 287.281 156.978 289.734 156.72Z"
      fill={$$props.pathColor}
    />
    <path
      d="M297.386 225.45C300.419 225.132 302.627 222.491 302.317 219.552C302.008 216.613 299.299 214.489 296.266 214.807C293.233 215.125 291.026 217.766 291.335 220.705C291.644 223.644 294.354 225.769 297.386 225.45Z"
      fill={$$props.pathColor}
    />
    <path
      d="M292.386 180.579C295.151 180.289 297.165 177.888 296.884 175.216C296.602 172.544 294.133 170.613 291.368 170.903C288.603 171.193 286.589 173.595 286.87 176.267C287.152 178.938 289.621 180.869 292.386 180.579Z"
      fill={$$props.pathColor}
    />
    <path
      d="M284.672 107.323C286.456 107.136 287.754 105.576 287.571 103.839C287.388 102.102 285.794 100.846 284.01 101.034C282.226 101.221 280.928 102.78 281.111 104.517C281.294 106.254 282.888 107.51 284.672 107.323Z"
      fill={$$props.pathColor}
    />
    <path
      d="M287.275 132.296C289.327 132.08 290.823 130.317 290.616 128.358C290.41 126.399 288.58 124.985 286.528 125.2C284.477 125.415 282.981 127.178 283.187 129.138C283.393 131.097 285.224 132.511 287.275 132.296Z"
      fill={$$props.pathColor}
    />
    <path
      d="M281.998 83.1615C283.469 83.007 284.541 81.7266 284.391 80.3016C284.241 78.8766 282.926 77.8466 281.454 78.0011C279.983 78.1556 278.911 79.436 279.061 80.861C279.211 82.286 280.526 83.316 281.998 83.1615Z"
      fill={$$props.pathColor}
    />
    <path
      d="M279.452 58.024C280.522 57.9116 281.302 56.9903 281.195 55.966C281.087 54.9418 280.132 54.2026 279.061 54.3149C277.991 54.4272 277.211 55.3486 277.319 56.3728C277.426 57.3971 278.381 58.1363 279.452 58.024Z"
      fill={$$props.pathColor}
    />
    <path
      d="M276.746 31.9392C277.638 31.8456 278.289 31.0838 278.2 30.2377C278.111 29.3916 277.315 28.7816 276.423 28.8752C275.531 28.9688 274.881 29.7306 274.97 30.5767C275.059 31.4228 275.854 32.0328 276.746 31.9392Z"
      fill={$$props.pathColor}
    />
    <path
      d="M274.315 3.41769C274.625 3.03491 274.566 2.47335 274.183 2.16338C273.799 1.85341 273.237 1.91242 272.926 2.2952C272.616 2.67797 272.675 3.23956 273.058 3.54953C273.442 3.8595 274.004 3.80047 274.315 3.41769Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.106 202.517C315.976 202.517 318.303 200.267 318.303 197.491C318.303 194.714 315.976 192.464 313.106 192.464C310.236 192.464 307.91 194.714 307.91 197.491C307.91 200.267 310.236 202.517 313.106 202.517Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.11 155.502C315.577 155.502 317.576 153.578 317.576 151.205C317.576 148.832 315.577 146.908 313.11 146.908C310.644 146.908 308.645 148.832 308.645 151.205C308.645 153.578 310.644 155.502 313.11 155.502Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.344 224.657C316.393 224.657 318.865 222.261 318.865 219.306C318.865 216.351 316.393 213.955 313.344 213.955C310.295 213.955 307.823 216.351 307.823 219.306C307.823 222.261 310.295 224.657 313.344 224.657Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.117 179.577C315.898 179.577 318.151 177.399 318.151 174.712C318.151 172.026 315.898 169.848 313.117 169.848C310.337 169.848 308.083 172.026 308.083 174.712C308.083 177.399 310.337 179.577 313.117 179.577Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.104 105.878C314.898 105.878 316.352 104.463 316.352 102.716C316.352 100.97 314.898 99.5544 313.104 99.5544C311.31 99.5544 309.856 100.97 309.856 102.716C309.856 104.463 311.31 105.878 313.104 105.878Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.116 131.015C315.178 131.015 316.851 129.418 316.851 127.447C316.851 125.477 315.178 123.88 313.116 123.88C311.053 123.88 309.381 125.477 309.381 127.447C309.381 129.418 311.053 131.015 313.116 131.015Z"
      fill={$$props.pathColor}
    />
    <path
      d="M312.947 81.6517C314.427 81.6517 315.627 80.4902 315.627 79.0573C315.627 77.6244 314.427 76.4629 312.947 76.4629C311.467 76.4629 310.268 77.6244 310.268 79.0573C310.268 80.4902 311.467 81.6517 312.947 81.6517Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.103 56.3425C314.18 56.3425 315.052 55.5076 315.052 54.4778C315.052 53.4479 314.18 52.613 313.103 52.613C312.027 52.613 311.155 53.4479 311.155 54.4778C311.155 55.5076 312.027 56.3425 313.103 56.3425Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.103 30.0911C314 30.0911 314.727 29.4014 314.727 28.5507C314.727 27.6999 314 27.0103 313.103 27.0103C312.206 27.0103 311.479 27.6999 311.479 28.5507C311.479 29.4014 312.206 30.0911 313.103 30.0911Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.698 1.49734C314.047 1.14905 314.047 0.584376 313.698 0.236095C313.35 -0.112186 312.784 -0.112183 312.435 0.236099C312.086 0.58438 312.086 1.14904 312.435 1.49732C312.784 1.8456 313.35 1.84562 313.698 1.49734Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.27 246.46C316.588 246.46 319.278 243.883 319.278 240.703C319.278 237.524 316.588 234.947 313.27 234.947C309.951 234.947 307.261 237.524 307.261 240.703C307.261 243.883 309.951 246.46 313.27 246.46Z"
      fill={$$props.pathColor}
    />
    <path
      d="M337.17 242.753C337.585 239.601 335.255 236.695 331.965 236.262C328.675 235.83 325.671 238.035 325.255 241.186C324.84 244.338 327.17 247.244 330.46 247.677C333.75 248.109 336.754 245.905 337.17 242.753Z"
      fill={$$props.pathColor}
    />
    <path
      d="M354.65 247.124C355.474 244.053 353.544 240.868 350.339 240.011C347.133 239.153 343.867 240.947 343.043 244.018C342.219 247.089 344.149 250.273 347.354 251.131C350.56 251.989 353.826 250.194 354.65 247.124Z"
      fill={$$props.pathColor}
    />
    <path
      d="M371.41 253.656C372.629 250.718 371.131 247.309 368.065 246.041C365 244.773 361.526 246.127 360.308 249.064C359.09 252.001 360.587 255.41 363.653 256.678C366.719 257.946 370.192 256.593 371.41 253.656Z"
      fill={$$props.pathColor}
    />
    <path
      d="M387.163 262.323C388.755 259.569 387.715 255.994 384.842 254.338C381.968 252.681 378.347 253.57 376.756 256.323C375.164 259.076 376.203 262.651 379.077 264.308C381.95 265.965 385.571 265.076 387.163 262.323Z"
      fill={$$props.pathColor}
    />
    <path
      d="M401.606 273.049C403.544 270.526 402.981 266.847 400.349 264.829C397.716 262.812 394.01 263.222 392.072 265.744C390.134 268.266 390.697 271.946 393.33 273.963C395.962 275.98 399.668 275.571 401.606 273.049Z"
      fill={$$props.pathColor}
    />
    <path
      d="M414.593 285.546C416.844 283.298 416.767 279.576 414.42 277.233C412.074 274.89 408.347 274.813 406.095 277.061C403.844 279.309 403.921 283.031 406.268 285.374C408.614 287.717 412.341 287.794 414.593 285.546Z"
      fill={$$props.pathColor}
    />
    <path
      d="M425.786 299.591C428.312 297.656 428.722 293.956 426.702 291.327C424.682 288.698 420.997 288.136 418.471 290.071C415.945 292.007 415.535 295.707 417.555 298.335C419.575 300.964 423.26 301.526 425.786 299.591Z"
      fill={$$props.pathColor}
    />
    <path
      d="M435.044 314.984C437.802 313.394 438.692 309.779 437.032 306.91C435.373 304.04 431.793 303.002 429.036 304.592C426.278 306.182 425.388 309.796 427.047 312.666C428.706 315.536 432.287 316.573 435.044 314.984Z"
      fill={$$props.pathColor}
    />
    <path
      d="M442.255 331.503C445.196 330.286 446.551 326.819 445.281 323.757C444.011 320.696 440.597 319.201 437.656 320.417C434.714 321.634 433.359 325.102 434.629 328.163C435.899 331.224 439.313 332.72 442.255 331.503Z"
      fill={$$props.pathColor}
    />
    <path
      d="M447.195 348.756C450.271 347.934 452.068 344.672 451.209 341.471C450.35 338.271 447.161 336.343 444.085 337.166C441.01 337.989 439.213 341.251 440.072 344.451C440.931 347.652 444.12 349.579 447.195 348.756Z"
      fill={$$props.pathColor}
    />
    <path
      d="M449.933 366.575C453.09 366.16 455.297 363.16 454.864 359.875C454.431 356.59 451.521 354.263 448.364 354.678C445.208 355.093 443 358.093 443.433 361.378C443.866 364.663 446.776 366.99 449.933 366.575Z"
      fill={$$props.pathColor}
    />
    <path
      d="M450.166 384.46C446.999 384.46 444.401 381.785 444.401 378.461C444.401 375.137 446.999 372.461 450.166 372.461C453.333 372.461 455.931 375.137 455.931 378.461C455.931 381.785 453.333 384.46 450.166 384.46Z"
      fill={$$props.pathColor}
    />
    <path
      d="M175.236 371.4C178.403 371.4 181.001 374.076 181.001 377.4C181.001 380.724 178.403 383.4 175.236 383.4C172.069 383.4 169.471 380.724 169.471 377.4C169.471 374.076 172.069 371.4 175.236 371.4Z"
      fill={$$props.pathColor}
    />
    <path
      d="M182.249 360.181C182.682 356.896 180.475 353.896 177.318 353.481C174.161 353.066 171.251 355.393 170.818 358.678C170.385 361.963 172.593 364.963 175.749 365.378C178.906 365.793 181.816 363.466 182.249 360.181Z"
      fill={$$props.pathColor}
    />
    <path
      d="M185.755 343.372C186.614 340.171 184.817 336.91 181.741 336.087C178.666 335.264 175.477 337.192 174.618 340.392C173.759 343.593 175.556 346.854 178.631 347.677C181.706 348.5 184.896 346.572 185.755 343.372Z"
      fill={$$props.pathColor}
    />
    <path
      d="M191.249 327.109C192.519 324.048 191.164 320.58 188.222 319.363C185.28 318.147 181.866 319.642 180.597 322.703C179.327 325.764 180.682 329.232 183.623 330.449C186.565 331.666 189.979 330.17 191.249 327.109Z"
      fill={$$props.pathColor}
    />
    <path
      d="M198.968 311.645C200.627 308.775 199.737 305.16 196.979 303.571C194.222 301.981 190.642 303.019 188.982 305.888C187.323 308.758 188.213 312.373 190.971 313.962C193.728 315.552 197.308 314.514 198.968 311.645Z"
      fill={$$props.pathColor}
    />
    <path
      d="M208.605 297.405C210.625 294.776 210.215 291.076 207.689 289.141C205.163 287.206 201.477 287.768 199.457 290.396C197.437 293.025 197.847 296.725 200.373 298.66C202.899 300.596 206.585 300.034 208.605 297.405Z"
      fill={$$props.pathColor}
    />
    <path
      d="M220.057 284.64C222.404 282.297 222.481 278.575 220.23 276.327C217.978 274.079 214.251 274.156 211.904 276.499C209.558 278.842 209.481 282.564 211.732 284.812C213.984 287.06 217.711 286.983 220.057 284.64Z"
      fill={$$props.pathColor}
    />
    <path
      d="M232.942 273.238C235.575 271.221 236.138 267.541 234.199 265.019C232.261 262.497 228.556 262.087 225.923 264.104C223.29 266.121 222.727 269.801 224.666 272.323C226.604 274.846 230.309 275.255 232.942 273.238Z"
      fill={$$props.pathColor}
    />
    <path
      d="M247.355 263.798C250.229 262.142 251.268 258.567 249.676 255.813C248.084 253.06 244.464 252.171 241.59 253.828C238.716 255.485 237.677 259.06 239.269 261.813C240.861 264.566 244.481 265.455 247.355 263.798Z"
      fill={$$props.pathColor}
    />
    <path
      d="M262.878 256.23C265.944 254.962 267.442 251.553 266.223 248.615C265.005 245.678 261.532 244.325 258.466 245.593C255.4 246.861 253.902 250.27 255.121 253.207C256.339 256.144 259.812 257.498 262.878 256.23Z"
      fill={$$props.pathColor}
    />
    <path
      d="M279.184 250.835C282.389 249.978 284.32 246.793 283.496 243.722C282.671 240.651 279.405 238.857 276.2 239.715C272.994 240.572 271.064 243.757 271.888 246.828C272.712 249.899 275.978 251.693 279.184 250.835Z"
      fill={$$props.pathColor}
    />
    <path
      d="M296.095 247.44C299.385 247.008 301.716 244.102 301.3 240.95C300.884 237.798 297.88 235.594 294.59 236.026C291.3 236.459 288.97 239.364 289.386 242.516C289.801 245.668 292.805 247.873 296.095 247.44Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.27 246.46C316.588 246.46 319.278 243.883 319.278 240.703C319.278 237.524 316.588 234.947 313.27 234.947C309.951 234.947 307.261 237.524 307.261 240.703C307.261 243.883 309.951 246.46 313.27 246.46Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.199 268.523C316.921 268.523 319.938 265.619 319.938 262.037C319.938 258.455 316.921 255.551 313.199 255.551C309.477 255.551 306.46 258.455 306.46 262.037C306.46 265.619 309.477 268.523 313.199 268.523Z"
      fill={$$props.pathColor}
    />
    <path
      d="M338.01 264.604C338.571 261.066 336.046 257.726 332.369 257.145C328.693 256.563 325.258 258.96 324.697 262.498C324.136 266.036 326.661 269.376 330.337 269.957C334.013 270.539 337.448 268.142 338.01 264.604Z"
      fill={$$props.pathColor}
    />
    <path
      d="M355.491 269.86C356.599 266.453 354.629 262.76 351.089 261.612C347.549 260.463 343.78 262.294 342.672 265.701C341.563 269.108 343.534 272.8 347.074 273.949C350.614 275.097 354.382 273.267 355.491 269.86Z"
      fill={$$props.pathColor}
    />
    <path
      d="M371.849 277.849C373.477 274.657 372.109 270.702 368.793 269.014C365.477 267.327 361.468 268.547 359.839 271.738C358.21 274.93 359.579 278.885 362.895 280.573C366.211 282.26 370.22 281.04 371.849 277.849Z"
      fill={$$props.pathColor}
    />
    <path
      d="M386.843 288.253C388.952 285.355 388.22 281.235 385.209 279.05C382.198 276.866 378.047 277.444 375.939 280.342C373.83 283.24 374.562 287.36 377.573 289.545C380.584 291.729 384.735 291.151 386.843 288.253Z"
      fill={$$props.pathColor}
    />
    <path
      d="M400.004 300.909C402.541 298.376 402.464 294.192 399.832 291.564C397.2 288.936 393.01 288.859 390.474 291.392C387.937 293.925 388.014 298.109 390.646 300.737C393.278 303.365 397.468 303.442 400.004 300.909Z"
      fill={$$props.pathColor}
    />
    <path
      d="M411.021 315.411C413.924 313.306 414.503 309.162 412.315 306.155C410.127 303.148 406.001 302.418 403.099 304.523C400.196 306.629 399.617 310.773 401.805 313.78C403.993 316.786 408.119 317.517 411.021 315.411Z"
      fill={$$props.pathColor}
    />
    <path
      d="M419.551 331.494C422.748 329.868 423.969 325.865 422.279 322.553C420.589 319.242 416.628 317.876 413.432 319.502C410.235 321.128 409.014 325.131 410.704 328.443C412.393 331.754 416.355 333.12 419.551 331.494Z"
      fill={$$props.pathColor}
    />
    <path
      d="M425.516 348.672C428.928 347.565 430.761 343.803 429.611 340.268C428.461 336.733 424.762 334.765 421.35 335.872C417.939 336.979 416.105 340.742 417.255 344.277C418.405 347.811 422.104 349.779 425.516 348.672Z"
      fill={$$props.pathColor}
    />
    <path
      d="M428.716 366.712C432.26 366.152 434.66 362.722 434.078 359.051C433.496 355.38 430.151 352.859 426.608 353.419C423.065 353.98 420.664 357.41 421.246 361.08C421.829 364.751 425.173 367.272 428.716 366.712Z"
      fill={$$props.pathColor}
    />
    <path
      d="M429.068 384.859C425.495 384.859 422.572 381.859 422.572 378.13C422.572 374.4 425.495 371.4 429.068 371.4C432.641 371.4 435.564 374.4 435.564 378.13C435.564 381.859 432.641 384.859 429.068 384.859Z"
      fill={$$props.pathColor}
    />
    <path
      d="M196.996 370.99C200.568 370.99 203.491 373.99 203.491 377.719C203.491 381.448 200.568 384.448 196.996 384.448C193.423 384.448 190.5 381.448 190.5 377.719C190.5 373.99 193.423 370.99 196.996 370.99Z"
      fill={$$props.pathColor}
    />
    <path
      d="M204.796 360.572C205.378 356.901 202.978 353.471 199.434 352.911C195.891 352.351 192.547 354.872 191.964 358.543C191.382 362.214 193.783 365.643 197.326 366.204C200.869 366.764 204.214 364.243 204.796 360.572Z"
      fill={$$props.pathColor}
    />
    <path
      d="M208.875 343.991C210.025 340.457 208.192 336.694 204.78 335.587C201.368 334.48 197.67 336.448 196.519 339.983C195.369 343.517 197.203 347.28 200.615 348.387C204.027 349.494 207.725 347.526 208.875 343.991Z"
      fill={$$props.pathColor}
    />
    <path
      d="M215.476 328.097C217.166 324.785 215.945 320.782 212.748 319.156C209.552 317.53 205.59 318.896 203.901 322.207C202.211 325.519 203.432 329.521 206.629 331.148C209.825 332.774 213.786 331.408 215.476 328.097Z"
      fill={$$props.pathColor}
    />
    <path
      d="M224.463 313.503C226.651 310.497 226.072 306.352 223.169 304.247C220.267 302.141 216.141 302.872 213.953 305.878C211.765 308.885 212.345 313.029 215.247 315.135C218.149 317.24 222.276 316.51 224.463 313.503Z"
      fill={$$props.pathColor}
    />
    <path
      d="M235.649 300.436C238.281 297.808 238.358 293.624 235.821 291.091C233.284 288.558 229.094 288.635 226.462 291.263C223.83 293.891 223.753 298.075 226.29 300.608C228.827 303.141 233.017 303.064 235.649 300.436Z"
      fill={$$props.pathColor}
    />
    <path
      d="M248.804 289.294C251.815 287.11 252.547 282.99 250.438 280.092C248.33 277.194 244.179 276.615 241.168 278.8C238.157 280.984 237.425 285.104 239.534 288.002C241.642 290.9 245.793 291.479 248.804 289.294Z"
      fill={$$props.pathColor}
    />
    <path
      d="M263.477 280.416C266.793 278.728 268.161 274.773 266.532 271.581C264.904 268.39 260.895 267.17 257.579 268.857C254.262 270.545 252.894 274.5 254.523 277.691C256.151 280.883 260.16 282.103 263.477 280.416Z"
      fill={$$props.pathColor}
    />
    <path
      d="M279.392 273.772C282.932 272.624 284.903 268.931 283.794 265.524C282.686 262.117 278.917 260.287 275.378 261.435C271.838 262.584 269.867 266.276 270.975 269.683C272.084 273.09 275.852 274.921 279.392 273.772Z"
      fill={$$props.pathColor}
    />
    <path
      d="M296.067 269.93C299.743 269.348 302.269 266.009 301.707 262.471C301.146 258.933 297.711 256.536 294.035 257.117C290.359 257.699 287.833 261.038 288.395 264.576C288.956 268.114 292.391 270.511 296.067 269.93Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.199 268.523C316.921 268.523 319.938 265.619 319.938 262.037C319.938 258.455 316.921 255.551 313.199 255.551C309.477 255.551 306.46 258.455 306.46 262.037C306.46 265.619 309.477 268.523 313.199 268.523Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.524 290.413C317.425 290.413 320.588 287.327 320.588 283.521C320.588 279.715 317.425 276.63 313.524 276.63C309.622 276.63 306.46 279.715 306.46 283.521C306.46 287.327 309.622 290.413 313.524 290.413Z"
      fill={$$props.pathColor}
    />
    <path
      d="M336.825 286.253C337.486 282.505 334.908 278.918 331.066 278.241C327.224 277.565 323.573 280.055 322.911 283.803C322.249 287.551 324.827 291.138 328.669 291.815C332.511 292.491 336.163 290.001 336.825 286.253Z"
      fill={$$props.pathColor}
    />
    <path
      d="M352.428 291.708C353.732 288.132 351.817 284.153 348.151 282.82C344.485 281.488 340.456 283.307 339.152 286.884C337.848 290.46 339.763 294.439 343.43 295.772C347.096 297.104 351.125 295.285 352.428 291.708Z"
      fill={$$props.pathColor}
    />
    <path
      d="M366.8 299.791C368.706 296.494 367.512 292.243 364.133 290.296C360.755 288.348 356.471 289.441 354.565 292.737C352.659 296.033 353.853 300.284 357.232 302.232C360.61 304.18 364.894 303.087 366.8 299.791Z"
      fill={$$props.pathColor}
    />
    <path
      d="M379.656 310.22C382.106 307.305 381.67 302.911 378.681 300.407C375.692 297.903 371.283 298.237 368.833 301.152C366.383 304.068 366.82 308.462 369.808 310.966C372.797 313.47 377.206 313.136 379.656 310.22Z"
      fill={$$props.pathColor}
    />
    <path
      d="M390.405 322.742C393.325 320.295 393.659 315.893 391.152 312.909C388.644 309.924 384.244 309.489 381.324 311.935C378.404 314.381 378.07 318.784 380.578 321.768C383.085 324.752 387.485 325.188 390.405 322.742Z"
      fill={$$props.pathColor}
    />
    <path
      d="M398.834 336.954C402.136 335.051 403.23 330.773 401.279 327.399C399.329 324.026 395.071 322.833 391.77 324.736C388.469 326.639 387.375 330.917 389.325 334.291C391.276 337.664 395.533 338.857 398.834 336.954Z"
      fill={$$props.pathColor}
    />
    <path
      d="M404.683 352.434C408.265 351.133 410.087 347.11 408.753 343.449C407.418 339.788 403.433 337.876 399.851 339.178C396.269 340.48 394.447 344.502 395.782 348.163C397.116 351.824 401.102 353.736 404.683 352.434Z"
      fill={$$props.pathColor}
    />
    <path
      d="M407.744 368.601C411.497 367.94 413.991 364.295 413.314 360.458C412.636 356.622 409.044 354.048 405.29 354.709C401.536 355.37 399.043 359.015 399.72 362.852C400.398 366.688 403.99 369.262 407.744 368.601Z"
      fill={$$props.pathColor}
    />
    <path
      d="M407.861 385.097C404.045 385.097 400.959 381.935 400.959 378.043C400.959 374.152 404.045 370.99 407.861 370.99C411.678 370.99 414.763 374.152 414.763 378.043C414.763 381.935 411.678 385.097 407.861 385.097Z"
      fill={$$props.pathColor}
    />
    <path
      d="M218.841 370.751C222.657 370.751 225.743 373.913 225.743 377.805C225.743 381.697 222.657 384.859 218.841 384.859C215.025 384.859 211.939 381.697 211.939 377.805C211.939 373.913 215.025 370.751 218.841 370.751Z"
      fill={$$props.pathColor}
    />
    <path
      d="M227.063 362.693C227.741 358.856 225.247 355.21 221.493 354.549C217.739 353.889 214.147 356.463 213.469 360.299C212.792 364.136 215.286 367.781 219.04 368.442C222.793 369.103 226.386 366.529 227.063 362.693Z"
      fill={$$props.pathColor}
    />
    <path
      d="M231.091 347.866C232.426 344.205 230.604 340.183 227.022 338.881C223.44 337.579 219.455 339.491 218.12 343.152C216.786 346.813 218.608 350.836 222.19 352.137C225.771 353.439 229.757 351.527 231.091 347.866Z"
      fill={$$props.pathColor}
    />
    <path
      d="M237.485 334.072C239.436 330.699 238.341 326.421 235.04 324.518C231.739 322.615 227.482 323.807 225.531 327.181C223.58 330.555 224.675 334.832 227.976 336.735C231.277 338.638 235.535 337.446 237.485 334.072Z"
      fill={$$props.pathColor}
    />
    <path
      d="M246.309 321.618C248.816 318.634 248.482 314.231 245.562 311.785C242.642 309.338 238.242 309.774 235.735 312.759C233.227 315.743 233.561 320.145 236.481 322.592C239.401 325.038 243.801 324.602 246.309 321.618Z"
      fill={$$props.pathColor}
    />
    <path
      d="M257.161 310.875C260.15 308.371 260.586 303.978 258.136 301.062C255.686 298.147 251.277 297.813 248.288 300.317C245.299 302.821 244.863 307.215 247.313 310.13C249.763 313.046 254.172 313.379 257.161 310.875Z"
      fill={$$props.pathColor}
    />
    <path
      d="M269.656 302.138C273.034 300.19 274.228 295.939 272.323 292.643C270.417 289.346 266.133 288.253 262.754 290.201C259.375 292.149 258.181 296.4 260.087 299.696C261.993 302.992 266.277 304.085 269.656 302.138Z"
      fill={$$props.pathColor}
    />
    <path
      d="M283.485 295.653C287.151 294.321 289.066 290.341 287.763 286.765C286.459 283.188 282.43 281.369 278.764 282.701C275.098 284.034 273.183 288.013 274.487 291.59C275.79 295.166 279.819 296.985 283.485 295.653Z"
      fill={$$props.pathColor}
    />
    <path
      d="M298.268 291.792C302.11 291.116 304.689 287.529 304.027 283.781C303.365 280.032 299.714 277.542 295.871 278.219C292.029 278.895 289.451 282.482 290.113 286.23C290.775 289.979 294.426 292.469 298.268 291.792Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.524 290.413C317.425 290.413 320.588 287.327 320.588 283.521C320.588 279.715 317.425 276.63 313.524 276.63C309.622 276.63 306.46 279.715 306.46 283.521C306.46 287.327 309.622 290.413 313.524 290.413Z"
      fill={$$props.pathColor}
    />
    <path
      d="M320.902 304.925C320.902 308.898 317.573 312.141 313.432 312.141C309.291 312.141 305.962 308.898 305.962 304.925C305.962 300.952 309.291 297.709 313.432 297.709C317.573 297.709 320.902 300.952 320.902 304.925Z"
      fill={$$props.pathColor}
    />
    <path
      d="M339.507 309.426C340.54 305.577 338.147 301.592 334.162 300.526C330.177 299.459 326.109 301.715 325.076 305.565C324.043 309.414 326.436 313.399 330.421 314.465C334.406 315.531 338.474 313.275 339.507 309.426Z"
      fill={$$props.pathColor}
    />
    <path
      d="M356.48 318.419C358.476 314.968 357.197 310.5 353.624 308.441C350.051 306.381 345.537 307.509 343.542 310.96C341.546 314.411 342.825 318.879 346.398 320.939C349.971 322.998 354.485 321.87 356.48 318.419Z"
      fill={$$props.pathColor}
    />
    <path
      d="M370.358 331.615C373.18 328.797 373.103 324.151 370.185 321.238C367.268 318.326 362.615 318.249 359.793 321.066C356.971 323.884 357.048 328.53 359.966 331.443C362.883 334.356 367.535 334.433 370.358 331.615Z"
      fill={$$props.pathColor}
    />
    <path
      d="M380.44 347.859C383.897 345.867 385.027 341.359 382.964 337.792C380.901 334.224 376.427 332.947 372.97 334.94C369.514 336.933 368.384 341.44 370.447 345.007C372.51 348.575 376.984 349.852 380.44 347.859Z"
      fill={$$props.pathColor}
    />
    <path
      d="M385.975 366.262C389.83 365.23 392.089 361.168 391.021 357.189C389.954 353.21 385.963 350.821 382.108 351.852C378.253 352.884 375.993 356.945 377.061 360.925C378.129 364.904 382.119 367.293 385.975 366.262Z"
      fill={$$props.pathColor}
    />
    <path
      d="M386.509 385.432C390.5 385.432 393.735 382.093 393.735 377.973C393.735 373.854 390.5 370.514 386.509 370.514C382.517 370.514 379.282 373.854 379.282 377.973C379.282 382.093 382.517 385.432 386.509 385.432Z"
      fill={$$props.pathColor}
    />
    <path
      d="M240.281 370.427C244.259 370.427 247.507 373.751 247.507 377.886C247.507 382.021 244.259 385.345 240.281 385.345C236.302 385.345 233.054 382.021 233.054 377.886C233.054 373.751 236.302 370.427 240.281 370.427Z"
      fill={$$props.pathColor}
    />
    <path
      d="M249.792 360.94C250.86 356.961 248.6 352.899 244.745 351.868C240.89 350.836 236.899 353.226 235.832 357.205C234.764 361.184 237.023 365.246 240.878 366.277C244.734 367.309 248.724 364.919 249.792 360.94Z"
      fill={$$props.pathColor}
    />
    <path
      d="M256.273 345.083C258.336 341.515 257.206 337.008 253.749 335.015C250.293 333.022 245.819 334.299 243.756 337.867C241.693 341.434 242.823 345.942 246.279 347.934C249.736 349.927 254.21 348.65 256.273 345.083Z"
      fill={$$props.pathColor}
    />
    <path
      d="M266.816 331.358C269.733 328.446 269.81 323.8 266.988 320.982C264.166 318.164 259.513 318.241 256.596 321.154C253.678 324.067 253.601 328.713 256.423 331.53C259.246 334.348 263.898 334.271 266.816 331.358Z"
      fill={$$props.pathColor}
    />
    <path
      d="M280.457 320.978C284.03 318.919 285.309 314.451 283.313 311C281.318 307.549 276.803 306.421 273.231 308.48C269.658 310.54 268.379 315.008 270.374 318.459C272.37 321.91 276.884 323.038 280.457 320.978Z"
      fill={$$props.pathColor}
    />
    <path
      d="M296.323 314.393C300.308 313.327 302.701 309.342 301.668 305.493C300.636 301.644 296.568 299.387 292.583 300.454C288.597 301.52 286.204 305.505 287.237 309.354C288.27 313.203 292.338 315.459 296.323 314.393Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.346 312.141C317.472 312.141 320.816 308.91 320.816 304.925C320.816 300.94 317.472 297.709 313.346 297.709C309.221 297.709 305.876 300.94 305.876 304.925C305.876 308.91 309.221 312.141 313.346 312.141Z"
      fill={$$props.pathColor}
    />
    <path
      d="M321.553 326.328C321.553 330.625 317.899 334.193 313.433 334.193C308.967 334.193 305.313 330.707 305.313 326.328C305.313 322.031 308.967 318.464 313.433 318.464C317.899 318.464 321.553 321.95 321.553 326.328Z"
      fill={$$props.pathColor}
    />
    <path
      d="M340.79 333.441C342.455 329.428 340.445 324.786 336.302 323.073C332.159 321.359 327.451 323.223 325.787 327.236C324.122 331.249 326.131 335.891 330.274 337.604C334.417 339.318 339.125 337.454 340.79 333.441Z"
      fill={$$props.pathColor}
    />
    <path
      d="M355.834 347.158C358.91 344.087 358.833 339.031 355.662 335.864C352.491 332.698 347.427 332.621 344.351 335.692C341.276 338.764 341.353 343.82 344.524 346.986C347.695 350.153 352.759 350.23 355.834 347.158Z"
      fill={$$props.pathColor}
    />
    <path
      d="M364.301 365.712C368.32 364.05 370.187 359.349 368.471 355.212C366.755 351.075 362.106 349.069 358.087 350.731C354.068 352.393 352.201 357.094 353.918 361.231C355.634 365.368 360.283 367.374 364.301 365.712Z"
      fill={$$props.pathColor}
    />
    <path
      d="M365.156 385.993C360.852 385.993 357.28 382.345 357.28 377.885C357.28 373.426 360.771 369.778 365.156 369.778C369.541 369.778 373.032 373.426 373.032 377.885C373.032 382.345 369.541 385.993 365.156 385.993Z"
      fill={$$props.pathColor}
    />
    <path
      d="M261.786 386.079C266.136 386.079 269.662 382.449 269.662 377.971C269.662 373.494 266.136 369.864 261.786 369.864C257.436 369.864 253.91 373.494 253.91 377.971C253.91 382.449 257.436 386.079 261.786 386.079Z"
      fill={$$props.pathColor}
    />
    <path
      d="M272.998 361.186C274.714 357.049 272.847 352.348 268.829 350.686C264.81 349.024 260.161 351.03 258.445 355.167C256.729 359.304 258.595 364.005 262.614 365.667C266.633 367.329 271.282 365.323 272.998 361.186Z"
      fill={$$props.pathColor}
    />
    <path
      d="M282.559 347.01C285.73 343.844 285.807 338.787 282.731 335.716C279.655 332.645 274.591 332.722 271.42 335.888C268.249 339.054 268.172 344.111 271.248 347.182C274.324 350.253 279.388 350.176 282.559 347.01Z"
      fill={$$props.pathColor}
    />
    <path
      d="M296.711 337.532C300.854 335.819 302.863 331.177 301.198 327.164C299.534 323.151 294.826 321.288 290.683 323.001C286.54 324.715 284.531 329.357 286.195 333.369C287.86 337.382 292.568 339.246 296.711 337.532Z"
      fill={$$props.pathColor}
    />
    <path
      d="M313.519 334.193C318.004 334.193 321.639 330.672 321.639 326.328C321.639 321.985 318.004 318.464 313.519 318.464C309.035 318.464 305.399 321.985 305.399 326.328C305.399 330.672 309.035 334.193 313.519 334.193Z"
      fill={$$props.pathColor}
    />
  </g>
  <defs>
    <clipPath id="clip0_6493_27950">
      <rect width="757" height="386" fill="white" transform="translate(-66)" />
    </clipPath>
  </defs>
</svg>
